<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <Header class="level-left" v-bind="$route.meta" />
      </div>
      <div>
        <b-field grouped>
          <b-field label="Start Date">
            <b-datepicker
              v-model="dateStart"
              name="dateStart"
              :first-day-of-week="1"
              :locale="'en-CA'"
              icon="calendar-alt"
              placeholder="Start Date"
            />
          </b-field>
          <b-field label="End Date">
            <b-datepicker
              v-model="dateEnd"
              name="dateEnd"
              :first-day-of-week="1"
              :locale="'en-CA'"
              icon="calendar-alt"
              placeholder="End Date"
            />
          </b-field>
          <b-field v-if="user.group.plants && user.group.plants.length != 0" label="Plant">
            <b-select v-model="selectedPlant" icon="industry" expanded>
              <option v-for="plant in user.group.plants" :key="plant.id" :value="plant">
                {{ plant.name }}
              </option>
            </b-select>
          </b-field>
          <b-field v-else label="Plant">
            <multiselect
              v-model="selectedPlant"
              :options="plants"
              :multiple="false"
              :close-on-select="true"
              placeholder="Pick plant"
              :custom-label="(obj) => obj.id + ' - ' + obj.name"
              track-by="name"
              style="min-width: 400px;"
            />
          </b-field>
          <b-field v-if="forecasts.length > 0" label="Types">
            <multiselect
              v-model="selectedTypes"
              :options="siteTypes"
              :multiple="true"
              :close-on-select="false"
              placeholder="Pick Types to forecast"
              :custom-label="(obj) => obj.name"
              track-by="name"
              style="min-width: 400px;"
            />
          </b-field>
        </b-field>
        <b-field grouped>
          <b-field>
            <b-button
              class="left-right"
              type="is-warning"
              icon-left="arrows-rotate"
              :disabled="isLoading || selectedPlant === null"
              @click="() => {resetData(); getData();}"
            >
              Load
            </b-button>
            <b-field v-if="selectedPlant && selectedPlant.id === 'FRA0'" label="Weekly Simorep Total" class="left-right ml-3">
              <b-input v-model="weeklyMeanSimorep" type="number" />
            </b-field>
            <b-button
              class="left-right ml-3"
              type="is-success"
              icon-left="download"
              :disabled="!forecasts.length > 0"
              @click="() => {exportToExcel()}"
            >
              Export xlsx
            </b-button>
            <b-button
              class="left-right ml-3"
              type="is-success"
              icon-left="upload"
              :disabled="isLoading || !forecasts.length > 0"
              @click="() => {isImportingExcel = true}"
            >
              Import xlsx
            </b-button>
            <b-button
              class="left-right ml-3"
              type="is-warning"
              icon-left="x"
              :disabled="!forecasts.length > 0"
              @click="() => {isResetting = true}"
            >
              Reset
            </b-button>
            <div style="margin-left: 10px; margin-right: -10px; display: flex; flex-direction: column;">
              <b-switch v-model="shipmentView">
                Shipment View
              </b-switch>
              <b-switch v-model="infoCard" style="margin-top: 5px;">
                Info Card
              </b-switch>
              <b-switch v-model="meanCard" style="margin-top: 5px;">
                Mean Card
              </b-switch>
            </div>
          </b-field>
          <b-field v-if="undecidedCollsOut.length > 0 || undecidedCollsIn.length > 0">
            <b-button
              class="left-right"
              type="is-success"
              icon-left="box"
              @click="() => {isCheckingUndecided = true}"
            >
              Undated Shipments
            </b-button>
          </b-field>
          <b-field v-if="forecasts.length > 0" label="Max Stocks" class="card px-2 py-2" grouped>
            <b-field>
              {{ "Max total: " + target.max_total }}
            </b-field>
            <b-field>
              {{ "Max Clean: " + target.max_clean }}
            </b-field>
          </b-field>
          <b-field v-if="forecasts.length > 0" label="Safety Stocks" class="card px-2 py-2" grouped>
            <b-field>
              {{ "Clean: " + target.min_clean }}
            </b-field>
            <b-field>
              {{ "Dirty: " + target.min_dirty }}
            </b-field>
            <b-field>
              {{ "Available: " + target.min_available }}
            </b-field>
            <b-field>
              {{ "Repair: " + target.min_repair }}
            </b-field>
          </b-field>
        </b-field>
      </div>
      <div v-if="forecasts.length > 0 && infoCard" class="card px-2 py-2" style="width: fit-content; position: fixed; top: 85px; right: 5px; z-index: 3;">
        <b-field> {{ selectedPlant.name }} </b-field>
        <b-field>
          <b-switch v-model="shipmentView">
            Shipment View
          </b-switch>
        </b-field>
        <b-field v-if="forecasts.length > 0" label="Max Stocks" grouped>
          <b-field>
            {{ "Max total: " + target.max_total }}
          </b-field>
          <b-field>
            {{ "Max Clean: " + target.max_clean }}
          </b-field>
        </b-field>
        <b-field v-if="forecasts.length > 0" label="Safety Stocks" grouped>
          <b-field>
            {{ "Clean: " + target.min_clean }}
          </b-field>
          <b-field>
            {{ "Dirty: " + target.min_dirty }}
          </b-field>
          <b-field>
            {{ "Available: " + target.min_available }}
          </b-field>
          <b-field>
            {{ "Repair: " + target.min_repair }}
          </b-field>
        </b-field>
        <b-button
          class="left-right mr-2"
          type="is-ghost"
          icon-left="x"
          :style="{'display': 'block', 'position': 'absolute', 'top': '0', 'right': '0'}"
          @click="() => {closeInfoCard()}"
        />
      </div>
      <div v-if="meanCard" class="card px-2 py-2" style="width: fit-content; position: fixed; top: 325px; right: 5px; z-index: 3;">
        <div style="margin-left: 10px; margin-right: 10px; display: flex; flex-direction: column;">
          <b-field>
            <b-switch v-model="collectMeanCounts">
              Collect Mean
            </b-switch>
          </b-field>
          <b-field>
            <b-switch v-model="washingMeanCounts">
              Washing Mean
            </b-switch>
          </b-field>
          <b-field>
            <b-switch v-model="repairMeanCounts">
              Repair Mean
            </b-switch>
          </b-field>
          <b-field>
            <b-switch v-model="rejectMeanCounts">
              Reject Mean
            </b-switch>
          </b-field>
          <!-- <b-field>
            <b-switch v-model="deliveryMeanCounts">
              Delivery Mean
            </b-switch>
          </b-field> -->
        </div>
        <b-button
          class="left-right mr-2"
          type="is-ghost"
          icon-left="x"
          :style="{'display': 'block', 'position': 'absolute', 'top': '0', 'right': '0'}"
          @click="() => {closeMeanCard()}"
        />
      </div>
      <div
        v-if="shipmentView && pendingCount > 0"
        class="card px-4 py-3"
        style="position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%); z-index: 20; display: flex; align-items: center; gap: 1rem; box-shadow: 0 2px 12px rgba(0,0,0,0.25); border: 2px solid rgb(255, 140, 0);"
      >
        <span style="font-weight: bold;">
          <b-icon icon="triangle-exclamation" size="is-small" style="color: rgb(255, 140, 0);" />
          {{ pendingCount }} unsaved shipment {{ pendingCount === 1 ? 'change' : 'changes' }}
        </span>
        <b-button
          type="is-success"
          icon-left="check"
          :loading="isSubmittingMoves"
          :disabled="isSubmittingMoves || isLoading"
          @click="() => { submitMoves() }"
        >
          Submit changes
        </b-button>
        <b-button
          type="is-light"
          icon-left="rotate-left"
          :disabled="isSubmittingMoves || isLoading"
          @click="() => { discardPending() }"
        >
          Discard
        </b-button>
      </div>
      <div
        v-for="(forecast, index) in forecasts"
        :key="forecast.date"
        class="card pl-2 py-1"
        :style="{
          'margin-top': '2rem',
          'padding-right': '0.75rem',
          'background-color': forecast.inventory ? 'rgb(252, 252, 149)' : holidays.includes(new Date(forecast.date).toLocaleDateString('en-CA')) ? 'rgb(50, 50, 50)' : '',
          'border': '2px solid transparent',
          'border-image-slice': '1',
          'border-image': 'linear-gradient(to left, rgb(125, 125, 125), rgb(225, 225, 225)) 3',
          'color': holidays.includes(new Date(forecast.date).toLocaleDateString('en-CA')) ? 'rgb(255, 255, 255)' : 'black'
        }"
      >
        <div :style="{'text-transform': 'capitalize'}">
          {{ new Date(forecast.date).toLocaleDateString("en-EN", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }) }}
        </div>
        <div v-if="!shipmentView" class="columns">
          <div
            v-for="type in selectedTypes"
            :key="type.name"
            class="column"
          >
            <div style="border-bottom: 1px rgb(100, 100, 100) solid; padding-left: 0.3rem;">
              {{ type.name }}
            </div>
            <div
              v-for="status in forecast.statuses"
              :key="status"
              style="background-color: rgba(245, 222, 179, 0.8); padding-left: 0.3rem; color: black;"
            >
              {{ status }}
              <span :style="forecast.values[type.name][status].num_crates >= 0 ? forecast.values[type.name][status].changed ? {color: 'blue'} : {} : {color: 'red'}">
                {{ forecast.values[type.name][status].num_crates.toFixed(0) }}
              </span>
            </div>
            <div
              :style="{
                'border-top': '1px rgb(190, 190, 190) solid',
                'background-color': 'rgba(190, 230, 250, 1)',
                'padding-left': '0.3rem',
                'color': 'black'
              }"
            >
              Washed <span
                :style="{
                  'color': forecast.washed[type.name] ? 'black' : simulations[forecast.date + '__' + 'washing' + '__' + type.name] ? 'rgb(76, 160, 76)' : 'blue'
                }"
              >
                {{ forecast.washed[type.name] !== null ? forecast.washed[type.name] : simulations[forecast.date + '__' + 'washing' + '__' + type.name] ? simulations[forecast.date + '__' + 'washing' + '__' + type.name] : !(washingDays.includes(new Date(forecast.date).getDay())) || !(new Date(forecast.date) > new Date().setDate(new Date().getDate() - 10)) ? 0 : crateMeans[type.name + '__' + 'washing']?.toFixed(1) }}
              </span>
            </div>
            <div
              :style="{
                'background-color': 'rgba(190, 230, 250, 1)',
                'padding-left': '0.3rem',
                'color': 'black'
              }"
            >
              Repaired <span :style="forecast.repaired[type.name] ? {} : simulations[forecast.date + '__' + 'repair' + '__' + type.name] ? {'color': 'rgb(76, 160, 76)'} : {'color': 'blue'}">{{ forecast.repaired[type.name] ? forecast.repaired[type.name] : simulations[forecast.date + '__' + 'repair' + '__' + type.name] ? simulations[forecast.date + '__' + 'repair' + '__' + type.name] : !(washingDays.includes(new Date(forecast.date).getDay())) || !(new Date(forecast.date) > new Date().setDate(new Date().getDate() - 10)) ? 0 : crateMeans[type.name + '__' + 'repair']?.toFixed(1) }}</span>
            </div>
            <div
              :style="{
                'cursor': 'pointer',
                'border-top': '1px rgb(190, 190, 190) solid',
                'background-color': 'rgba(180, 250, 160, 1)',
                'padding-left': '0.3rem',
                'color': 'black'
              }"
              @click="() => {collsInDisplayed = true; checkCollects(crateIOs[type.name][index])}"
            >
              In <span :style="crateIOs[type.name][index].doneCollsIn.length > 0 ? {} : crateIOs[type.name][index].simIn ? {'color': 'green'} : new Date(forecast.date) > new Date().setDate(new Date().getDate() + 1) ? (crateIOs[type.name][index].totalIn >= collMeans[type.name] || !(washingDays.includes(new Date(forecast.date).getDay()))) ? {'color': 'blue'} : {'color': 'brown'} : crateIOs[type.name][index].predCollsIn.length > 0 ? {'color': 'blue'} : {}">{{ new Date(forecast.date) > new Date().setDate(new Date().getDate() + 1) ? (crateIOs[type.name][index].totalIn >= collMeans[type.name] || !(washingDays.includes(new Date(forecast.date).getDay()))) ? crateIOs[type.name][index].totalIn : collMeans[type.name]?.toFixed(1) : crateIOs[type.name][index].totalIn }}</span>
            </div>
            <div
              :style="{
                'cursor': 'pointer',
                'background-color': 'rgba(180, 250, 160, 1)',
                'padding-left': '0.3rem',
                'color': 'black'
              }"
              @click="() => {collsInDisplayed = false; checkCollects(crateIOs[type.name][index])}"
            >
              Out <span :style="crateIOs[type.name][index].doneCollsOut.length > 0 ? {} : crateIOs[type.name][index].simOut ? {'color': 'green'} : crateIOs[type.name][index].predCollsOut.length > 0 ? {'color': 'blue'} : {}">{{ crateIOs[type.name][index].totalOut }}</span>
            </div>
          </div>
          <div class="column" :style="{ 'color': holidays.includes(new Date(forecast.date).toLocaleDateString('en-CA')) ? 'rgb(255, 255, 255)' : 'black' }">
            <div :style="{ 'font-weight': 'bold' }">
              Max
            </div>
            <table :style="{ 'border-spacing': '1rem 0px', 'border-collapse': 'separate' }">
              <tr>
                <td>{{ "Total:" }}</td>
                <td>{{ forecast.total.toFixed(0) }}</td>
                <td :style="{ color: (forecast.total/target.max_total * 100) > 80 ? 'red' : 'black' }">
                  {{ target.max_total && target.max_total !== 0 ? (forecast.total/target.max_total * 100).toFixed(0) + '%' : '' }}
                </td>
              </tr>
              <tr>
                <td>{{ "Clean:" }}</td>
                <td>{{ forecast.clean.toFixed(0) }}</td>
                <td :style="{ color: (forecast.clean/target.max_clean * 100) > 80 ? 'red' : 'black' }">
                  {{ target.max_clean && target.max_clean !== 0 ? (forecast.clean/target.max_clean * 100).toFixed(0) + '%' : '' }}
                </td>
              </tr>
            </table>
            <div :style="{ 'font-weight': 'bold' }">
              Safety
            </div>
            <table :style="{ 'border-spacing': '1rem 0px', 'border-collapse': 'separate' }">
              <tr>
                <td>{{ "Available:" }}</td>
                <td>{{ forecast.available.toFixed(0) }}</td>
                <td :style="{ color: (forecast.available/target.min_available * 100) < 100 ? 'red' : 'green' }">
                  {{ target.min_available && target.min_available !== 0 ? (forecast.available/target.min_available * 100).toFixed(0) + '%' : '' }}
                </td>
              </tr>
              <tr>
                <td>{{ "Clean:" }}</td>
                <td>{{ forecast.clean.toFixed(0) }}</td>
                <td :style="{ color: (forecast.clean/target.min_clean * 100) < 100 ? 'red' : 'green' }">
                  {{ target.min_clean && target.min_clean !== 0 ? (forecast.clean/target.min_clean * 100).toFixed(0) + '%' : '' }}
                </td>
              </tr>
              <tr>
                <td>{{ "Dirty:" }}</td>
                <td>{{ forecast.dirty.toFixed(0) }}</td>
                <td :style="{ color: (forecast.dirty/target.min_dirty * 100) < 100 ? 'red' : 'green' }">
                  {{ target.min_dirty && target.min_dirty !== 0 ? (forecast.dirty/target.min_dirty * 100).toFixed(0) + '%' : '' }}
                </td>
              </tr>
              <tr>
                <td>{{ "Repair:" }}</td>
                <td>{{ forecast.repair.toFixed(0) }}</td>
                <td :style="{ color: (forecast.repair/target.min_repair * 100) < 100 ? 'red' : 'green' }">
                  {{ target.min_repair && target.min_repair !== 0 ? (forecast.repair/target.min_repair * 100).toFixed(0) + '%' : '' }}
                </td>
              </tr>
            </table>
          </div>
          <b-button
            class="left-right mr-2"
            type="is-ghost"
            icon-left="door-closed"
            :style="{'display': 'block', 'position': 'absolute', 'right': '60px', 'margin-top': '-10px', 'color': 'black' }"
            :disabled="isLoading"
            @click="() => { addHoliday(new Date(forecast.date).toLocaleDateString('en-CA')) }"
          />
          <b-button
            v-if="holidays.includes(new Date(forecast.date).toLocaleDateString('en-CA'))"
            class="left-right mr-2"
            type="is-ghost"
            icon-left="x"
            :style="{'display': 'block', 'position': 'absolute', 'right': '60px', 'margin-top': '-10px', 'color': 'red' }"
            :disabled="isLoading"
            @click="() => { removeHoliday(new Date(forecast.date).toLocaleDateString('en-CA')) }"
          />
          <b-tooltip
            :label="forecast.comment?.text"
            :active="forecast.comment ? true : false"
            multilined
          >
            <b-button
              class="left-right mr-2"
              type="is-ghost"
              :icon-left="forecast.comment ? 'star' : 'comment'"
              :style="{'display': 'block', 'position': 'absolute', 'right': '30px', 'margin-top': '-10px', 'color': forecast.comment ? 'gold' : 'gray'}"
              :disabled="isLoading"
              @click="() => {editComment(forecast)}"
            />
          </b-tooltip>
          <b-button
            class="left-right mr-2"
            type="is-ghost"
            icon-left="edit"
            :style="{'display': 'block', 'position': 'absolute', 'right': '0', 'margin-top': '-10px'}"
            :disabled="isLoading"
            @click="() => {editForecast(forecast)}"
          />
        </div>
        <div
          v-if="shipmentView"
          :style="{
            'position': 'relative',
            'border-radius': '4px',
            'outline': dragOverDate === forecast.date ? '3px dashed rgb(70, 110, 220)' : 'none',
            'outline-offset': '2px'
          }"
          @dragover.prevent="onDragOver($event, forecast.date)"
          @drop.prevent="onDrop(forecast.date)"
        >
          <div :style="{'display': 'flex', 'justify-content': 'flex-end', 'align-items': 'center', 'gap': '0.5rem', 'padding': '0 0.25rem 0.25rem'}">
            <span v-if="dragOverDate === forecast.date" :style="{'font-size': '0.8rem', 'color': 'rgb(70, 110, 220)', 'font-weight': 'bold'}">
              Drop to move the shipment here
            </span>
            <b-button
              size="is-small"
              type="is-info"
              icon-left="plus"
              @click="() => { openNewPrediction(forecast.date) }"
            >
              Add prediction
            </b-button>
          </div>
          <div
            :style="{
              'display': 'flex',
              'flex-direction': 'row',
              'justify-content': 'space-around'
            }"
          >
            <div
              :style="{
                'height': '15rem',
                'max-height': '15rem',
                'overflow-y': 'scroll',
                '-ms-overflow-style': 'none',
                'scrollbarWidth': '0',
                'width': '45%'
              }"
            >
              <table
                :style="{
                  'display': 'flex',
                  'flex-direction': 'column',
                  'border': '2px solid rgb(140 140 140)',
                  'width' : '100%',
                  'border-spacing': '0.5rem 0px',
                  'border-collapse': 'collapse',
                  'text-align': 'left'
                }"
              >
                <thead style="position: sticky; top: 0; background-color: lightgray; display: table; width: 100%;">
                  <tr>
                    <td style="width: 10ch; max-width: 10ch; overflow: hidden; white-space: nowrap;">
                      Origin
                    </td>
                    <td style="width: 10ch; max-width: 10ch;">
                      OB
                    </td>
                    <td style="width: 6ch; max-width: 6ch;">
                      RO
                    </td>
                    <td style="width: 4ch; max-width: 4ch;">
                      Nbr
                    </td>
                    <td style="width: 4ch; max-width: 4ch;">
                      Type
                    </td>
                    <td style="width: 6ch; max-width: 6ch;">
                      Status
                    </td>
                  </tr>
                </thead>
                <tbody style="width: 100%; display: table;">
                  <tr
                    v-for="move in forecast.dayMoves.doneCollsIn"
                    :key="'donecollsin' + move._key"
                    :title="move._moved ? 'A move exists for this OB but it was scanned — the real scan wins' : ''"
                    :style="{
                      'color': move.relic ? 'blue' : 'black',
                      'font-weight': move.naval ? 'bold' : 'regular',
                      'background-color': move.shipType === 'COL'? 'rgb(162, 200, 215)' : 'rgb(162, 200, 255)',
                      'border-top': 'solid 1px rgb(220, 220, 220)',
                      'border-left': 'solid 1px rgb(220, 220, 220)',
                      'border-right': 'solid 1px rgb(220, 220, 220)',
                      'outline': move._moved ? '2px dotted rgb(150, 150, 150)' : '',
                      'outline-offset': '-2px'
                    }"
                  >
                    <td style="width: 10ch; max-width: 10ch; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      {{ move.name }}
                    </td>
                    <td style="width: 10ch; max-width: 10ch;">
                      {{ move.id }}
                    </td>
                    <td style="width: 6ch; max-width: 6ch;">
                      {{ move.shipment }}
                    </td>
                    <td style="width: 4ch; max-width: 4ch;">
                      {{ parseInt(move.num_crates) }}
                    </td>
                    <td style="width: 4ch; max-width: 4ch;">
                      {{ move.type }}
                    </td>
                    <td style="width: 6ch; max-width: 6ch;">
                      {{ move.status }}
                    </td>
                  </tr>
                  <tr
                    v-for="move in forecast.dayMoves.predCollsIn"
                    :key="'predcollsin' + move._key"
                    :draggable="isMovable(move)"
                    :title="moveTitle(move)"
                    :style="{
                      'color': move.relic ? 'blue' : 'black',
                      'font-weight': move.naval ? 'bold' : 'regular',
                      'background-color': move.shipType === 'COL'? 'rgb(162, 200, 215)' : 'rgb(162, 200, 255)',
                      'border-top': 'solid 1px rgb(220, 220, 220)',
                      'border-left': 'solid 1px rgb(220, 220, 220)',
                      'border-right': 'solid 1px rgb(220, 220, 220)',
                      'outline': moveOutline(move),
                      'outline-offset': '-2px',
                      'cursor': isMovable(move) ? 'grab' : 'default'
                    }"
                    @dragstart="onDragStart($event, move)"
                    @dragend="onDragEnd"
                  >
                    <td style="width: 10ch; max-width: 10ch; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      {{ move.name }}
                    </td>
                    <td style="width: 10ch; max-width: 10ch;">
                      {{ move.id }}
                    </td>
                    <td style="width: 6ch; max-width: 6ch;">
                      {{ move.shipment }}
                    </td>
                    <td style="width: 4ch; max-width: 4ch;">
                      {{ parseInt(move.num_crates) }}
                    </td>
                    <td style="width: 4ch; max-width: 4ch;">
                      {{ move.type }}
                    </td>
                    <td style="width: 6ch; max-width: 6ch;">
                      {{ move.status }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              :style="{
                'height': '15rem',
                'max-height': '15rem',
                'overflow-y': 'scroll',
                'width': '45%'
              }"
            >
              <table
                :style="{
                  'display': 'flex',
                  'flex-direction': 'column',
                  'border': '2px solid rgb(140 140 140)',
                  'width' : '100%',
                  'border-spacing': '1rem 0px',
                  'border-collapse': 'collapse',
                  'text-align': 'left'
                }"
              >
                <thead style="position: sticky; top: 0; background-color: lightgray; display: table; width: 100%;">
                  <tr>
                    <td style="width: 10ch; max-width: 10ch; overflow: hidden; white-space: nowrap;">
                      Destination
                    </td>
                    <td style="width: 10ch; max-width: 10ch;">
                      OB
                    </td>
                    <td style="width: 6ch; max-width: 6ch;">
                      RO
                    </td>
                    <td style="width: 4ch; max-width: 4ch;">
                      Nbr
                    </td>
                    <td style="width: 4ch; max-width: 4ch;">
                      Type
                    </td>
                    <td style="width: 6ch; max-width: 6ch;">
                      Status
                    </td>
                  </tr>
                </thead>
                <tbody style="width: 100%; display: table;">
                  <tr
                    v-for="move in forecast.dayMoves.doneCollsOut"
                    :key="'donecollsout' + move._key"
                    :title="move._moved ? 'A move exists for this OB but it was scanned — the real scan wins' : ''"
                    :style="{
                      'color': move.relic ? 'blue' : 'black',
                      'font-weight': move.naval ? 'bold' : 'regular',
                      'background-color': move.shipType === 'DEL'? 'rgb(146, 208, 80)': 'rgb(251, 226, 213)',
                      'border-top': 'solid 1px rgb(220, 220, 220)',
                      'border-left': 'solid 1px rgb(220, 220, 220)',
                      'border-right': 'solid 1px rgb(220, 220, 220)',
                      'outline': move._moved ? '2px dotted rgb(150, 150, 150)' : '',
                      'outline-offset': '-2px'
                    }"
                  >
                    <td style="width: 10ch; max-width: 10ch; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      {{ move.name }}
                    </td>
                    <td style="width: 10ch; max-width: 10ch;">
                      {{ move.id }}
                    </td>
                    <td style="width: 6ch; max-width: 6ch;">
                      {{ move.shipment }}
                    </td>
                    <td style="width: 4ch; max-width: 4ch;">
                      {{ parseInt(move.num_crates) }}
                    </td>
                    <td style="width: 4ch; max-width: 4ch;">
                      {{ move.type }}
                    </td>
                    <td style="width: 6ch; max-width: 6ch;">
                      {{ move.status }}
                    </td>
                  </tr>
                  <tr
                    v-for="move in forecast.dayMoves.predCollsOut"
                    :key="'predcollsout' + move._key"
                    :draggable="isMovable(move)"
                    :title="moveTitle(move)"
                    :style="{
                      'color': move.relic ? 'blue' : 'black',
                      'font-weight': move.naval ? 'bold' : 'regular',
                      'background-color': move.shipType === 'DEL'? 'rgb(146, 208, 80)': 'rgb(251, 226, 213)',
                      'border-top': 'solid 1px rgb(220, 220, 220)',
                      'border-left': 'solid 1px rgb(220, 220, 220)',
                      'border-right': 'solid 1px rgb(220, 220, 220)',
                      'outline': moveOutline(move),
                      'outline-offset': '-2px',
                      'cursor': isMovable(move) ? 'grab' : 'default'
                    }"
                    @dragstart="onDragStart($event, move)"
                    @dragend="onDragEnd"
                  >
                    <td style="width: 10ch; max-width: 10ch; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      {{ move.name }}
                    </td>
                    <td style="width: 10ch; max-width: 10ch;">
                      {{ move.id }}
                    </td>
                    <td style="width: 6ch; max-width: 6ch;">
                      {{ move.shipment }}
                    </td>
                    <td style="width: 4ch; max-width: 4ch;">
                      {{ parseInt(move.num_crates) }}
                    </td>
                    <td style="width: 4ch; max-width: 4ch;">
                      {{ move.type }}
                    </td>
                    <td style="width: 6ch; max-width: 6ch;">
                      {{ move.status }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal key="undecided" :active.sync="isCheckingUndecided" scroll="keep" has-modal-card>
      <div v-if="isCheckingUndecided" style="margin-left: -20vw;">
        <div class="modal-card" style="min-width: 70vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Undated Movements
              <span v-if="storedName" style="font-size:1rem; text-overflow: elipsis">{{ storedName }}</span>
            </p>
          </header>
          <section class="modal-card-body">
            <div style="display: flex; align-items: center; margin-top: -20px; margin-bottom: 20px">
              View Crates OUT
              <b-switch v-model="collsInDisplayed" style="margin-left: 10px;" />
              View Crates IN
              <b-button
                size="is-small"
                style="margin-left: 20px;"
                @click="hideOldUndecided = !hideOldUndecided"
              >
                {{ hideOldUndecided ? 'Show older movements' : 'Hide older movements' }}
              </b-button>
              <div style="margin-left: auto; font-weight: bold;">
                Total (last week): {{ collsInDisplayed ? totalRecentUndecidedIn : totalRecentUndecidedOut }}
                <span style="margin-left: 15px;">
                  Total (all): {{ collsInDisplayed ? totalUndecidedIn : totalUndecidedOut }}
                </span>
              </div>
            </div>
            <div v-if="collsInDisplayed">
              <div class="columns" style="background-color: rgb(255, 255, 255);">
                <div class="column">
                  Origin
                </div>
                <div class="column">
                  OB
                </div>
                <div class="column">
                  RO
                </div>
                <div class="column">
                  Quantity
                </div>
                <div class="column">
                  Type
                </div>
                <div class="column">
                  Status
                </div>
                <div class="column">
                  Date
                </div>
              </div>
              <div
                v-for="undecidedCollIn in displayedUndecidedCollsIn"
                :key="undecidedCollIn.id"
                class="columns"
                :style="{
                  'color': undecidedCollIn.relic ? 'blue' : 'black',
                  'font-weight': undecidedCollIn.naval ? 'bold' : 'regular',
                  'background-color': 'rgb(162, 200, 215)',
                  'border-top': 'solid 1px rgb(220, 220, 220)',
                  'border-left': 'solid 1px rgb(220, 220, 220)',
                  'border-right': 'solid 1px rgb(220, 220, 220)'
                }"
              >
                <div class="shipping-detail">
                  <b-tooltip :label="undecidedCollIn.name" position="is-right">
                    <div style="overflow: hidden; text-overflow: ellipsis; text-wrap: nowrap; width: 18ch;">
                      {{ undecidedCollIn.name }}
                    </div>
                  </b-tooltip>
                </div>
                <div class="shipping-detail">
                  {{ undecidedCollIn.id }}
                </div>
                <div class="shipping-detail">
                  {{ undecidedCollIn.shipment }}
                </div>
                <div class="shipping-detail">
                  {{ parseInt(undecidedCollIn.num_crates) }}
                </div>
                <div class="shipping-detail">
                  {{ undecidedCollIn.type }}
                </div>
                <div class="shipping-detail">
                  {{ undecidedCollIn.status }}
                </div>
                <div class="shipping-detail">
                  {{ undecidedCollIn.originDate }}
                </div>
              </div>
            </div>
            <div v-if="!collsInDisplayed">
              <div class="columns" style="background-color: rgb(255, 255, 255);">
                <div class="column">
                  Destination
                </div>
                <div class="column">
                  OB
                </div>
                <div class="column">
                  RO
                </div>
                <div class="column">
                  Quantity
                </div>
                <div class="column">
                  Type
                </div>
                <div class="column">
                  Status
                </div>
                <div class="column">
                  Date
                </div>
              </div>
              <div
                v-for="undecidedCollOut in displayedUndecidedCollsOut"
                :key="undecidedCollOut.id"
                class="columns"
                :style="{
                  'color': 'black',
                  'font-weight': 'regular',
                  'background-color': undecidedCollOut.shipType === 'DEL'? 'rgb(146, 208, 80)': 'rgb(251, 226, 213)',
                  'border-top': 'solid 1px rgb(220, 220, 220)',
                  'border-left': 'solid 1px rgb(220, 220, 220)',
                  'border-right': 'solid 1px rgb(220, 220, 220)'
                }"
              >
                <div class="shipping-detail">
                  <b-tooltip :label="undecidedCollOut.name" position="is-right">
                    <div style="overflow: hidden; text-overflow: ellipsis; text-wrap: nowrap; width: 18ch;">
                      {{ undecidedCollOut.name }}
                    </div>
                  </b-tooltip>
                </div>
                <div class="shipping-detail">
                  {{ undecidedCollOut.id }}
                </div>
                <div class="shipping-detail">
                  {{ undecidedCollOut.shipment }}
                </div>
                <div class="shipping-detail">
                  {{ parseInt(undecidedCollOut.num_crates) }}
                </div>
                <div class="shipping-detail">
                  {{ undecidedCollOut.type }}
                </div>
                <div class="shipping-detail">
                  {{ undecidedCollOut.status }}
                </div>
                <div class="shipping-detail">
                  {{ undecidedCollOut.originDate }}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </b-modal>
    <b-modal :active.sync="isImportingExcel" scroll="keep" has-modal-card>
      <div v-if="isImportingExcel" style="margin-left: -20vw;">
        <div class="modal-card" style="min-width: 70vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Import Excel Simulations
              <span v-if="storedName" style="font-size:1rem; text-overflow: elipsis">{{ storedName }}</span>
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-field>
                <input
                  id="fileUpload"
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  hidden
                  @change="loadFile"
                >
                <b-button class="btn" @click="chooseFiles">
                  Choose File
                </b-button>
              </b-field>
              <b-field>
                <b-button
                  class="left-right"
                  type="is-warning"
                  icon-left="x"
                  :disabled="!loadedExcel"
                  @click="() => {testExcel()}"
                >
                  Read Simulations
                </b-button>
              </b-field>
            </b-field>
            <div v-if="days && days.length > 0" style="margin-top: 5px; margin-bottom: 20px;">
              <div v-for="(day, index) in days" :key="'simulation' + index">
                <b-field grouped style="background-color: white; padding: 5px; width: fit-content;">
                  <b-field>{{ new Date(day.date).toLocaleDateString('en-CA') }}</b-field>
                  <b-field>{{ day.type }}</b-field>
                  <b-field>{{ day.operation }}</b-field>
                  <b-field>{{ day.num_crates }}</b-field>
                </b-field>
              </div>
            </div>
            <div v-if="newFalseShipments && newFalseShipments.length > 0" style="margin-top: 5px; margin-bottom: 20px;">
              <div v-for="(newFalseShipment, index) in newFalseShipments" :key="'simulation' + index">
                <b-field grouped style="background-color: white; padding: 5px; width: fit-content;">
                  <b-field>{{ new Date(newFalseShipment.date).toLocaleDateString('en-CA') }}</b-field>
                  <b-field>{{ newFalseShipment.name }}</b-field>
                  <b-field>{{ newFalseShipment.qty }}</b-field>
                </b-field>
              </div>
            </div>
            <b-field>
              <b-button
                class="left-right"
                type="is-warning"
                icon-left="x"
                :disabled="days.length <= 0 && newFalseShipments.length <= 0"
                @click="() => {saveSimulations()}"
              >
                Save Simulations
              </b-button>
            </b-field>
          </section>
        </div>
      </div>
    </b-modal>

    <b-modal :key="'resetModal'" :active.sync="isResetting" scroll="keep" has-modal-card>
      <div v-if="isResetting" style="margin-left: -20vw;">
        <div class="modal-card" style="min-width: 70vw; width: fit-content; min-height: 60vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Reset Fake Data
              <span v-if="storedName" style="font-size:1rem; text-overflow: elipsis">{{ storedName }}</span>
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-button
                class="left-right"
                type="is-warning"
                icon-left="x"
                :disabled="isLoading"
                @click="() => {resetSimulations({ simulations: true })}"
              >
                Reset Simulations
              </b-button>
              <b-button
                class="left-right ml-3"
                type="is-warning"
                icon-left="x"
                :disabled="isLoading"
                @click="() => {resetSimulations({ falseShipments: true })}"
              >
                Reset Fake Shipments
              </b-button>
              <b-button
                class="left-right ml-3"
                type="is-warning"
                icon-left="x"
                :disabled="isLoading"
                @click="() => {resetSimulations({ movedShipments: true })}"
              >
                Reset Moved Shipments
              </b-button>
              <b-button
                class="left-right ml-3"
                type="is-danger"
                icon-left="trash"
                :disabled="isLoading"
                @click="() => {resetSimulations({ simulations: true, falseShipments: true, movedShipments: true })}"
              >
                Reset All
              </b-button>
            </b-field>
            <p style="margin-bottom: 15px; color: rgb(120, 120, 120);">
              Most recently created content for this site. Resets cannot be undone.
            </p>
            <b-field grouped>
              <b-field label="Show">
                <b-select v-model="resetTableType" @input="selectedResetRows = []">
                  <option value="simulations">
                    Simulations
                  </option>
                  <option value="falseShipments">
                    Fake Shipments
                  </option>
                  <option value="movedShipments">
                    Moved Shipments
                  </option>
                </b-select>
              </b-field>
              <b-field label="&nbsp;">
                <b-button
                  type="is-danger"
                  icon-left="trash"
                  :disabled="isLoading || selectedResetRows.length === 0"
                  @click="() => {archiveSelected()}"
                >
                  Archive Selected ({{ selectedResetRows.length }})
                </b-button>
              </b-field>
            </b-field>
            <div
              :style="{
                'max-height': '24rem',
                'overflow-y': 'auto',
                'border': '1px solid rgb(200, 200, 200)'
              }"
            >
              <div
                v-if="resetTableType === 'simulations'"
                class="columns"
                style="position: sticky; top: 0; background-color: lightgray; margin: 0; font-weight: bold;"
              >
                <div class="column is-1">
                  <b-checkbox v-model="allResetRowsSelected" />
                </div>
                <div class="column">
                  Date
                </div>
                <div class="column">
                  Type
                </div>
                <div class="column">
                  Operation
                </div>
                <div class="column">
                  Crates
                </div>
              </div>
              <div
                v-else-if="resetTableType === 'movedShipments'"
                class="columns"
                style="position: sticky; top: 0; background-color: lightgray; margin: 0; font-weight: bold;"
              >
                <div class="column is-1">
                  <b-checkbox v-model="allResetRowsSelected" />
                </div>
                <div class="column">
                  Date
                </div>
                <div class="column">
                  OB
                </div>
                <div class="column">
                  Type
                </div>
                <div class="column">
                  Status
                </div>
                <div class="column">
                  Crates
                </div>
                <div class="column">
                  Kind
                </div>
              </div>
              <div
                v-else
                class="columns"
                style="position: sticky; top: 0; background-color: lightgray; margin: 0; font-weight: bold;"
              >
                <div class="column is-1">
                  <b-checkbox v-model="allResetRowsSelected" />
                </div>
                <div class="column">
                  Date
                </div>
                <div class="column">
                  Name
                </div>
                <div class="column">
                  Quantity
                </div>
              </div>
              <div
                v-for="(row, index) in resetTableRows"
                :key="'resetrow' + index"
                class="columns"
                :style="{
                  'margin': '0',
                  'background-color': index % 2 === 0 ? 'rgb(245, 245, 245)' : 'white'
                }"
              >
                <div class="column is-1">
                  <b-checkbox v-model="selectedResetRows" :native-value="row.id" />
                </div>
                <template v-if="resetTableType === 'simulations'">
                  <div class="column">
                    {{ new Date(row.date).toLocaleDateString('en-CA') }}
                  </div>
                  <div class="column">
                    {{ row.type }}
                  </div>
                  <div class="column">
                    {{ row.operation }}
                  </div>
                  <div class="column">
                    {{ parseInt(row.num_crates) }}
                  </div>
                </template>
                <template v-else-if="resetTableType === 'movedShipments'">
                  <div class="column">
                    {{ String(row.moved_date).slice(0, 10) }}
                  </div>
                  <div class="column">
                    {{ row.is_new ? 'PREVISION' : row.ob }}
                  </div>
                  <div class="column">
                    {{ row.crate_type }}
                  </div>
                  <div class="column">
                    {{ row.crate_status }}
                  </div>
                  <div class="column">
                    {{ row.num_crates !== null && row.num_crates !== undefined ? parseInt(row.num_crates) : '—' }}
                  </div>
                  <div class="column">
                    {{ row.is_new ? 'New' : 'Move' }}
                  </div>
                </template>
                <template v-else>
                  <div class="column">
                    {{ new Date(row.date).toLocaleDateString('en-CA') }}
                  </div>
                  <div class="column">
                    {{ row.name }}
                  </div>
                  <div class="column">
                    {{ parseInt(row.qty) }}
                  </div>
                </template>
              </div>
              <div v-if="resetTableRows.length === 0" style="padding: 1rem; text-align: center; color: rgb(150, 150, 150);">
                No {{ resetTableType === 'simulations' ? 'simulations' : resetTableType === 'movedShipments' ? 'moved shipments' : 'fake shipments' }} for this site.
              </div>
            </div>
          </section>
        </div>
      </div>
    </b-modal>

    <b-modal :key="'predictionModal'" :active.sync="isAddingPrediction" scroll="keep" has-modal-card>
      <form v-if="isAddingPrediction" @submit.prevent="addPrediction">
        <div class="modal-card" style="min-width: 40vw; width: fit-content; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              New predicted shipment
              <span v-if="storedName" style="font-size:1rem;">{{ storedName }}</span>
            </p>
          </header>
          <section class="modal-card-body">
            <p style="margin-bottom: 15px; color: rgb(120, 120, 120);">
              Staged locally. It appears on the forecast immediately and is saved when you submit your changes.
            </p>
            <b-field grouped>
              <b-field label="Date">
                <b-datepicker
                  v-model="predictionDate"
                  name="predictionDate"
                  :first-day-of-week="1"
                  :locale="'en-CA'"
                  icon="calendar-alt"
                  placeholder="Arrival / departure date"
                />
              </b-field>
              <b-field label="Requirement type">
                <b-select v-model="newPrediction.shipment_type">
                  <option value="COL">
                    COL (collect, in)
                  </option>
                  <option value="TRFI">
                    TRFI (transfer in)
                  </option>
                  <option value="NCR">
                    NCR (in)
                  </option>
                  <option value="DEL">
                    DEL (delivery, out)
                  </option>
                  <option value="TRFO">
                    TRFO (transfer out)
                  </option>
                </b-select>
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field label="Crate type">
                <b-select v-model="newPrediction.crate_type">
                  <option v-for="t in siteTypes" :key="'ptype' + t.name" :value="t.name === '5.X' ? '5.2' : t.name">
                    {{ t.name === '5.X' ? '5.2' : t.name }}
                  </option>
                </b-select>
              </b-field>
              <b-field label="Status">
                <b-select v-model="newPrediction.crate_status">
                  <option value="CLEAN">
                    CLEAN
                  </option>
                  <option value="DIRTY">
                    DIRTY
                  </option>
                  <option value="REPAIR">
                    REPAIR
                  </option>
                </b-select>
              </b-field>
              <b-field label="Quantity">
                <b-input v-model="newPrediction.num_crates" type="number" min="1" step="1" />
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field label="Ship from" expanded>
                <b-input v-if="!predictionIsIn" :value="storedPlantId" readonly />
                <b-input v-else v-model="newPrediction.ship_from" placeholder="Origin code" />
              </b-field>
              <b-field label="Ship to" expanded>
                <b-input v-if="predictionIsIn" :value="storedPlantId" readonly />
                <b-input v-else v-model="newPrediction.ship_to" placeholder="Destination code" />
              </b-field>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <button type="submit" class="button is-info is-fullwidth">
              Add to pending changes
            </button>
          </footer>
        </div>
      </form>
    </b-modal>

    <b-modal
      :key="colModalKey"
      :active.sync="isCheckingColls"
      scroll="keep"
      has-modal-card
    >
      <div v-if="isCheckingColls" style="margin-left: -20vw;">
        <div class="modal-card" style="min-width: 70vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Movements
              <span v-if="storedName" style="font-size:1rem; text-overflow: elipsis">{{ storedName }}</span>
              <span v-if="displayedColls.collDate" class="ml-3" style="font-size:1rem; text-overflow: elipsis">{{ displayedColls.collDate }}</span>
            </p>
          </header>
          <section class="modal-card-body">
            <div style="display: flex; align-items: center; margin-top: -20px; margin-bottom: 20px">
              View Crates OUT
              <b-switch v-model="collsInDisplayed" style="margin-left: 10px;" />
              View Crates IN
            </div>
            <div v-if="collsInDisplayed">
              <div class="columns" style="background-color: rgb(255, 255, 255);">
                <div class="column">
                  Origin
                </div>
                <div class="column">
                  OB
                </div>
                <div class="column">
                  RO
                </div>
                <div class="column">
                  Quantity
                </div>
                <div class="column">
                  Type
                </div>
                <div class="column">
                  Status
                </div>
                <div class="column">
                  Date
                </div>
              </div>
              <div
                v-for="doneCollIn in displayedColls.doneCollsIn"
                :key="doneCollIn.id"
                class="columns"
                :style="{
                  'color': doneCollIn.relic ? 'blue' : 'black',
                  'font-weight': doneCollIn.naval ? 'bold' : 'regular',
                  'background-color': 'rgb(162, 200, 215)',
                  'border-top': 'solid 1px rgb(220, 220, 220)',
                  'border-left': 'solid 1px rgb(220, 220, 220)',
                  'border-right': 'solid 1px rgb(220, 220, 220)'
                }"
              >
                <div class="shipping-detail">
                  <b-tooltip :label="doneCollIn.name" position="is-right">
                    <div style="overflow: hidden; text-overflow: ellipsis; text-wrap: nowrap; width: 18ch;">
                      {{ doneCollIn.name }}
                    </div>
                  </b-tooltip>
                </div>
                <div class="shipping-detail">
                  {{ doneCollIn.id }}
                </div>
                <div class="shipping-detail">
                  {{ doneCollIn.shipment }}
                </div>
                <div class="shipping-detail">
                  {{ parseInt(doneCollIn.num_crates) }}
                </div>
                <div class="shipping-detail">
                  {{ doneCollIn.type }}
                </div>
                <div class="shipping-detail">
                  {{ doneCollIn.status }}
                </div>
                <div class="shipping-detail">
                  {{ doneCollIn.done_date }}
                </div>
              </div>
              <div
                v-for="predCollIn in displayedColls.predCollsIn"
                :key="predCollIn.id"
                class="columns"
                :style="{
                  'color': predCollIn.relic ? 'blue' : 'black',
                  'font-weight': predCollIn.naval ? 'bold' : 'regular',
                  'background-color': 'rgb(162, 200, 215)',
                  'border-top': 'solid 1px rgb(220, 220, 220)',
                  'border-left': 'solid 1px rgb(220, 220, 220)',
                  'border-right': 'solid 1px rgb(220, 220, 220)'
                }"
              >
                <div class="shipping-detail">
                  <b-tooltip :label="predCollIn.name" position="is-right">
                    <div style="overflow: hidden; text-overflow: ellipsis; text-wrap: nowrap; width: 18ch;">
                      {{ predCollIn.name }}
                    </div>
                  </b-tooltip>
                </div>
                <div class="shipping-detail">
                  {{ predCollIn.id }}
                </div>
                <div class="shipping-detail">
                  {{ predCollIn.shipment }}
                </div>
                <div class="shipping-detail">
                  {{ parseInt(predCollIn.num_crates) }}
                </div>
                <div class="shipping-detail">
                  {{ predCollIn.type }}
                </div>
                <div class="shipping-detail">
                  {{ predCollIn.status }}
                </div>
                <div class="shipping-detail">
                  {{ predCollIn.originDate }}
                </div>
              </div>
            </div>
            <div v-if="!collsInDisplayed">
              <div class="columns" style="background-color: rgb(255, 255, 255);">
                <div class="column">
                  Destination
                </div>
                <div class="column">
                  OB
                </div>
                <div class="column">
                  RO
                </div>
                <div class="column">
                  Quantity
                </div>
                <div class="column">
                  Type
                </div>
                <div class="column">
                  Status
                </div>
                <div class="column">
                  Date
                </div>
              </div>
              <div
                v-for="doneCollOut in displayedColls.doneCollsOut"
                :key="doneCollOut.id"
                class="columns"
                :style="{
                  'color': doneCollOut.relic ? 'blue' : 'black',
                  'font-weight': doneCollOut.naval ? 'bold' : 'regular',
                  'background-color': doneCollOut.shipType === 'DEL'? 'rgb(146, 208, 80)': 'rgb(251, 226, 213)',
                  'border-top': 'solid 1px rgb(220, 220, 220)',
                  'border-left': 'solid 1px rgb(220, 220, 220)',
                  'border-right': 'solid 1px rgb(220, 220, 220)'
                }"
              >
                <div class="shipping-detail">
                  <b-tooltip :label="doneCollOut.name" position="is-right">
                    <div style="overflow: hidden; text-overflow: ellipsis; text-wrap: nowrap; width: 18ch;">
                      {{ doneCollOut.name }}
                    </div>
                  </b-tooltip>
                </div>
                <div class="shipping-detail">
                  {{ doneCollOut.id }}
                </div>
                <div class="shipping-detail">
                  {{ doneCollOut.shipment }}
                </div>
                <div class="shipping-detail">
                  {{ parseInt(doneCollOut.num_crates) }}
                </div>
                <div class="shipping-detail">
                  {{ doneCollOut.type }}
                </div>
                <div class="shipping-detail">
                  {{ doneCollOut.status }}
                </div>
                <div class="shipping-detail">
                  {{ doneCollOut.done_date }}
                </div>
              </div>
              <div
                v-for="predCollOut in displayedColls.predCollsOut"
                :key="predCollOut.id"
                class="columns"
                :style="{
                  'color': predCollOut.relic ? 'blue' : 'black',
                  'font-weight': predCollOut.naval ? 'bold' : 'regular',
                  'background-color': predCollOut.shipType === 'DEL'? 'rgb(146, 208, 80)': 'rgb(251, 226, 213)',
                  'border-top': 'solid 1px rgb(220, 220, 220)',
                  'border-left': 'solid 1px rgb(220, 220, 220)',
                  'border-right': 'solid 1px rgb(220, 220, 220)'
                }"
              >
                <div class="shipping-detail">
                  <b-tooltip :label="predCollOut.name" position="is-right">
                    <div style="overflow: hidden; text-overflow: ellipsis; text-wrap: nowrap; width: 18ch;">
                      {{ predCollOut.name }}
                    </div>
                  </b-tooltip>
                </div>
                <div class="shipping-detail">
                  {{ predCollOut.id }}
                </div>
                <div class="shipping-detail">
                  {{ predCollOut.shipment }}
                </div>
                <div class="shipping-detail">
                  {{ parseInt(predCollOut.num_crates) }}
                </div>
                <div class="shipping-detail">
                  {{ predCollOut.type }}
                </div>
                <div class="shipping-detail">
                  {{ predCollOut.status }}
                </div>
                <div class="shipping-detail">
                  {{ predCollOut.originDate }}
                </div>
              </div>
            </div>
            <div v-if="displayedFalseShipments && displayedFalseShipments.length > 0">
              <div class="columns mt-4" style="background-color: white;">
                <div class="shipping-detail">
                  Name
                </div>
                <div class="shipping-detail">
                  Quantity
                </div>
              </div>
              <div
                v-for="(ship, index) in displayedFalseShipments"
                :key="index + '-displayedships'"
                class="columns"
                :style="{
                  'background-color': 'gainsboro',
                  'border-top': 'solid 1px rgb(255, 255, 255)',
                  'border-left': 'solid 1px rgb(255, 255, 255)',
                  'border-right': 'solid 1px rgb(255, 255, 255)'
                }"
              >
                <div class="shipping-detail">
                  {{ ship.name }}
                </div>
                <div class="shipping-detail">
                  {{ ship.qty }}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </b-modal>

    <b-modal :key="'commentModal'" :active.sync="isEditingComment" scroll="keep" has-modal-card>
      <form v-if="isEditingComment" @submit.prevent="submitComment(false)">
        <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Edit Comment
              <span v-if="storedName" style="font-size:1rem; text-overflow: elipsis">{{ storedName }}</span>
              <span v-if="editableComment.date" class="ml-3" style="font-size:1rem; text-overflow: elipsis">{{ editableComment.date }}</span>
            </p>
          </header>
          <section class="modal-card-body">
            <b-field label="Comment">
              <b-input v-model="bufferText" type="textarea" />
            </b-field>
            <b-button
              class="left-right"
              type="is-danger"
              icon-left="box"
              @click="() => {submitComment(true)}"
            >
              Delete
            </b-button>
          </section>
          <footer class="modal-card-foot">
            <button type="submit" class="button is-info is-fullwidth">
              {{ $t('global.submit') }}
            </button>
          </footer>
        </div>
      </form>
    </b-modal>

    <b-modal :key="modalKey" :active.sync="isEditingForecast" scroll="keep" has-modal-card>
      <form v-if="isEditingForecast" novalidate @submit.prevent="submitEdit">
        <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Edit performance forecast
              <span v-if="storedName" style="font-size:1rem; text-overflow: elipsis">{{ storedName }}</span>
              <span v-if="editableForecast.date" class="ml-3" style="font-size:1rem; text-overflow: elipsis">{{ editableForecast.date }}</span>
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-field label="Start Date">
                <b-datepicker
                  v-model="editDateStart"
                  name="editDateStart"
                  :first-day-of-week="1"
                  :locale="'en-CA'"
                  icon="calendar-alt"
                  placeholder="Start Date"
                />
              </b-field>
              <b-field v-if="editBatch" label="End Date">
                <b-datepicker
                  v-model="editDateEnd"
                  name="editDateEnd"
                  :first-day-of-week="1"
                  :locale="'en-CA'"
                  icon="calendar-alt"
                  placeholder="End Date"
                />
              </b-field>
              <b-field label="Multiple Days?">
                <b-checkbox v-model="editBatch" name="batchEdit" />
              </b-field>
            </b-field>
            <div class="columns">
              <div
                v-for="type in editableForecast.types"
                :key="type"
                class="column"
              >
                <div>{{ type }}</div>
                <div
                  v-for="status in editableForecast.statuses"
                  :key="status"
                >
                  {{ status }}
                  <span :style=" editableForecast.values[type][status].changed ? {color: 'blue'} : {}">
                    {{ editableForecast.values[type][status].num_crates }}
                  </span>
                </div>
                <b-field label="Washed" label-position="on-border" class="mt-1">
                  <b-input v-model="editableWashed[type]" :disabled="editableWashed[type] === null" type="number" step="1" />
                  <b-button icon-left="circle-xmark" type="is-warning" class="is-small" @click="() => {editableWashed[type] = null; modalKey += 1}" />
                </b-field>
                <b-field label="Repaired" label-position="on-border" class="mt-1">
                  <b-input v-model="editableRepaired[type]" :disabled="editableRepaired[type] === null" type="number" step="1" />
                  <b-button icon-left="circle-xmark" type="is-warning" class="is-small" @click="() => {editableRepaired[type] = null; modalKey += 1}" />
                </b-field>
                <b-field label="In" label-position="on-border" class="mt-1">
                  <b-input v-model="editableIn[type]" :disabled="editableIn[type] === null" type="number" step="1" />
                  <b-button icon-left="circle-xmark" type="is-warning" class="is-small" @click="() => {editableIn[type] = null; modalKey += 1}" />
                </b-field>
                <b-field label="Out" label-position="on-border" class="mt-1">
                  <b-input v-model="editableOut[type]" :disabled="editableOut[type] === null" type="number" step="1" />
                  <b-button icon-left="circle-xmark" type="is-warning" class="is-small" @click="() => {editableOut[type] = null; modalKey += 1}" />
                </b-field>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button type="submit" class="button is-info is-fullwidth">
              {{ $t('global.submit') }}
            </button>
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Plant from '../../services/v2/plant'
import Forecast from '../../services/v3/crateForecast'
import exceljs from 'exceljs'
import { saveAs } from 'file-saver'

export default {
  name: 'CrateForecast',
  components: {
  },
  data: function () {
    return {
      dateStart: JSON.parse(sessionStorage.getItem('dateStart')) ? new Date(JSON.parse(sessionStorage.getItem('dateStart'))): new Date(),
      dateEnd: JSON.parse(sessionStorage.getItem('dateEnd')) ? new Date(JSON.parse(sessionStorage.getItem('dateEnd'))): new Date(),
      isLoading: false,
      infoCard: true,
      meanCard: true,
      holidays: [],
      modalKey: 0,
      colModalKey: -1,
      activeTab: '5.2',
      selectedPlant: JSON.parse(sessionStorage.getItem('consultingPlant')),
      storedPlantId: null,
      storedName: null,
      shipmentView: false,
      editDate: null,
      plants: [],
      siteTypes: [],
      selectedTypes: [],
      types: [{ name: '1' }, { name: '5.1' }, { name: '5.2' }, { name: '5.5' }, { name: '5.X' }, { name: 'FOOD' }, { name: 'ZEON' }, { name: 'RHODIA' }],
      forecasts: [],
      simulations: [],
      crateForecasts: [],
      crateMeans: [],
      collMeans: [],
      target: [],
      inventories: [],
      falseShipments: [],
      falseStart: [],
      falseEnd: [],
      displayedFalseShipments: [],
      washingDays: [],
      crateIOs: [],
      bookings: [],
      collectMeanCounts: true,
      washingMeanCounts: true,
      repairMeanCounts: true,
      rejectMeanCounts: false,
      deliveryMeanCounts: false,
      isEditingForecast: false,
      isEditingComment: false,
      isCheckingColls: false,
      isCheckingUndecided: false,
      isResetting: false,
      resetTableType: 'simulations',
      selectedResetRows: [],
      collsInDisplayed: true,
      hideOldUndecided: false,
      editableForecast: [],
      editableComment: [],
      bufferText: null,
      displayedColls: [],
      undecidedCollsIn: [],
      undecidedCollsOut: [],
      totalUndecidedIn: 0,
      totalUndecidedOut: 0,
      originalWashed: [],
      editableWashed: [],
      originalRepaired: [],
      editableRepaired: [],
      originalIn: [],
      editableIn: [],
      originalOut: [],
      editableOut: [],
      editDateStart: null,
      editDateEnd: null,
      editBatch: false,
      pinnedData: [],
      file: null,
      fileBuffer: null,
      days: [],
      isImportingExcel: false,
      loadedExcel: false,
      rawSimData: [],
      lastDate: '',
      weeklyMeanSimorep: 0,
      // --- moved shipments (drag & drop + new predictions) ---
      collects: [], // working copy of forecast collects, mutated optimistically on move/create
      movedShipments: [], // raw saved move/prediction records for the site (from the forecast payload)
      simData: [], // kept so the shipment view can be rebuilt after an optimistic move
      simLimit: null,
      draggingOb: null, // OB (collect id) currently being dragged
      dragOverDate: null, // day card currently hovered while dragging
      dragPointerY: 0, // last pointer Y during a drag, for edge auto-scroll
      dragScrollRaf: null, // requestAnimationFrame handle for edge auto-scroll
      pendingNewCounter: 0,
      isSubmittingMoves: false,
      isAddingPrediction: false,
      predictionDate: null,
      newPrediction: {
        shipment_type: 'COL',
        ship_from: '',
        ship_to: '',
        crate_type: '5.2',
        crate_status: 'DIRTY',
        num_crates: null
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    weekAgoStr () {
      const d = new Date()
      d.setDate(d.getDate() - 7)
      return d.toLocaleDateString('en-CA')
    },
    recentUndecidedCollsIn () {
      return this.undecidedCollsIn.filter(x => x.originDate === null || x.originDate >= this.weekAgoStr)
    },
    recentUndecidedCollsOut () {
      return this.undecidedCollsOut.filter(x => x.originDate === null || x.originDate >= this.weekAgoStr)
    },
    displayedUndecidedCollsIn () {
      return this.hideOldUndecided ? this.recentUndecidedCollsIn : this.undecidedCollsIn
    },
    displayedUndecidedCollsOut () {
      return this.hideOldUndecided ? this.recentUndecidedCollsOut : this.undecidedCollsOut
    },
    totalRecentUndecidedIn () {
      return this.recentUndecidedCollsIn.reduce((sum, element) => sum + parseInt(element.num_crates), 0)
    },
    totalRecentUndecidedOut () {
      return this.recentUndecidedCollsOut.reduce((sum, element) => sum + parseInt(element.num_crates), 0)
    },
    resetTableRows () {
      if (this.resetTableType === 'movedShipments') {
        return [...this.movedShipments].sort((a, b) => new Date(b.moved_date) - new Date(a.moved_date))
      }
      const source = this.resetTableType === 'falseShipments' ? this.falseShipments : this.rawSimData
      return [...source].sort((a, b) => new Date(b.date) - new Date(a.date))
    },
    // Number of unsaved shipment changes staged this session: OBs relocated to a new
    // day + brand-new predictions not yet persisted. Drives the pending-changes bar.
    predictionIsIn () {
      return ['COL', 'TRFI', 'NCR'].includes(this.newPrediction.shipment_type)
    },
    pendingCount () {
      const movedObs = new Set()
      let creates = 0
      this.collects.forEach((c) => {
        if (c._new) {
          creates += 1
        } else if (this.normDate(c.date) !== this.normDate(c._baseDate)) {
          movedObs.add(c.id)
        }
      })
      return movedObs.size + creates
    },
    allResetRowsSelected: {
      get () {
        return this.resetTableRows.length > 0 && this.selectedResetRows.length === this.resetTableRows.length
      },
      set (val) {
        this.selectedResetRows = val ? this.resetTableRows.map(row => row.id) : []
      }
    }
  },
  mounted: async function () {
    if (this.user.group.plants.length === 0) {
      this.plants = await Plant.getAll()
    }
  },
  methods: {
    resetData () {
      this.forecasts = []
      this.crateForecasts = []
      this.crateMeans = []
      this.collMeans = []
      this.falseShipments = []
      this.displayedFalseShipments = []
      this.crateIOs = []
      this.simulations = []
      this.editableForecast = []
      this.editableComment = []
      this.bufferText = null
      this.displayedColls = []
      this.undecidedCollsIn = []
      this.undecidedCollsOut = []
      this.totalUndecidedIn = 0
      this.totalUndecidedOut = 0
      this.originalWashed = []
      this.target = []
      this.inventories = []
      this.washingDays = []
      this.editableWashed = []
      this.originalRepaired = []
      this.editableRepaired = []
      this.selectedTypes = []
      this.originalIn = []
      this.editableIn = []
      this.originalOut = []
      this.editableOut = []
      this.editDateEnd = null
      this.editDateStart = null
      this.editBatch = false
      this.fileBuffer = null
      this.days = []
      this.newFalseShipments = []
      this.rawSimData = []
      this.collects = []
      this.movedShipments = []
      this.simData = []
      this.simLimit = null
      this.draggingOb = null
      this.dragOverDate = null
    },
    editForecast (forecast) {
      this.editableForecast = forecast
      this.editableForecast.types.forEach((type) => {
        let collVals = this.crateIOs[type].filter(x => {
          return new Date(x.collDate).toLocaleDateString('en-CA') === new Date(forecast.date).toLocaleDateString('en-CA')
        })
        this.originalRepaired[type] = this.simulations[forecast.date + '__' + 'repair' + '__' + type] ? this.simulations[forecast.date + '__' + 'repair' + '__' + type] : this.crateMeans[type + '__' + 'repair']
        this.originalWashed[type] = this.simulations[forecast.date + '__' + 'washing' + '__' + type] ? this.simulations[forecast.date + '__' + 'washing' + '__' + type] : this.crateMeans[type + '__' + 'washing']
        this.editableRepaired[type] = this.simulations[forecast.date + '__' + 'repair' + '__' + type] ? this.simulations[forecast.date + '__' + 'repair' + '__' + type] : this.crateMeans[type + '__' + 'repair']
        this.editableWashed[type] = this.simulations[forecast.date + '__' + 'washing' + '__' + type] ? this.simulations[forecast.date + '__' + 'washing' + '__' + type] : this.crateMeans[type + '__' + 'washing']
        this.originalIn[type] = collVals[0].totalIn
        this.editableIn[type] = collVals[0].totalIn
        this.originalOut[type] = collVals[0].totalOut
        this.editableOut[type] = collVals[0].totalOut
        if (!collVals[0].simIn && new Date(forecast.date) > new Date().setDate(new Date().getDate() + 1) && collVals[0].totalIn < this.collMeans[type]) {
          this.originalIn[type] = this.collMeans[type]
          this.editableIn[type] = this.collMeans[type]
        }
      })
      this.editDateStart = new Date(this.editableForecast.date)
      this.editDateEnd = null
      this.editBatch = false
      this.isEditingForecast = true
    },
    editComment (forecast) {
      this.editableComment = forecast
      if (this.editableComment.comment) {
        this.bufferText = this.editableComment.comment.text
      }
      this.isEditingComment = true
    },
    checkCollects (collects) {
      this.displayedColls = collects
      this.displayedFalseShipments = this.falseShipments.filter((x) => { return new Date(x.date).toLocaleDateString('en-CA') === collects.collDate })
      this.isCheckingColls = true
    },
    addHoliday (date) {
      Forecast.createHoliday({
        date: date,
        id_site: this.storedPlantId
      }).then(async (res) => {
        this.holidays = await Forecast.getHolidays({
          siteId: this.selectedPlant.id
        })
        this.holidays = this.holidays.map((x) => { return new Date(x.date).toLocaleDateString('en-CA') })
      })
    },
    removeHoliday (date) {
      Forecast.removeHoliday({
        date: date,
        id_site: this.storedPlantId
      }).then(async (res) => {
        this.holidays = await Forecast.getHolidays({
          siteId: this.selectedPlant.id
        })
        this.holidays = this.holidays.map((x) => { return new Date(x.date).toLocaleDateString('en-CA') })
      })
    },
    async loadFile (file) {
      this.file = file.target.files[0]
      const reader = new FileReader()

      reader.onload = (event) => {
        this.fileBuffer = event.target.result
      }
      await reader.readAsArrayBuffer(this.file)
      this.loadedExcel = true
    },
    chooseFiles: function () {
      document.getElementById('fileUpload').click()
    },
    async testExcel () {
      var readWb = new exceljs.Workbook()
      const excelCollumns = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      await readWb.xlsx.load(this.fileBuffer)
      var display = readWb.getWorksheet('Crate Forecasts')
      var backup = readWb.getWorksheet('DONT TOUCH')
      var currentDate = display.getCell('A1').value
      this.falseStart = new Date(currentDate)
      var out = []
      var simFalseShipments = []
      var index = 0
      while (currentDate && currentDate.length > 0) {
        this.target.types.forEach((type, typeNum) => {
          let washed = display.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 5)).value
          let backupWashed = backup.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 5)).value
          if (washed !== backupWashed) {
            out.push({
              num_crates: parseInt(washed),
              operation: 'washing',
              id_site: this.storedPlantId,
              date: currentDate,
              type: display.getCell(excelCollumns[typeNum + 1] + ((index * 14) + 2)).value
            })
          }
          let repaired = display.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 6)).value
          let backupRepaired = backup.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 6)).value
          if (repaired !== backupRepaired) {
            out.push({
              num_crates: parseInt(repaired),
              operation: 'repair',
              id_site: this.storedPlantId,
              date: currentDate,
              type: display.getCell(excelCollumns[typeNum + 1] + ((index * 14) + 2)).value
            })
          }
          let inClean = display.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 7)).value
          let backupInClean = backup.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 7)).value
          if (inClean !== backupInClean) {
            out.push({
              num_crates: parseInt(inClean),
              operation: 'in__clean',
              id_site: this.storedPlantId,
              date: currentDate,
              type: display.getCell(excelCollumns[typeNum + 1] + ((index * 14) + 2)).value
            })
          }
          let inDirty = display.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 8)).value
          let backupInDirty = backup.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 8)).value
          if (inDirty !== backupInDirty) {
            out.push({
              num_crates: parseInt(inDirty),
              operation: 'in__dirty',
              id_site: this.storedPlantId,
              date: currentDate,
              type: display.getCell(excelCollumns[typeNum + 1] + ((index * 14) + 2)).value
            })
          }
          let inRepair = display.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 9)).value
          let backupInRepair = backup.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 9)).value
          if (inRepair !== backupInRepair) {
            out.push({
              num_crates: parseInt(inRepair),
              operation: 'in__repair',
              id_site: this.storedPlantId,
              date: currentDate,
              type: display.getCell(excelCollumns[typeNum + 1] + ((index * 14) + 2)).value
            })
          }
          let outClean = display.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 10)).value
          let backupOutClean = backup.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 10)).value
          if (outClean !== backupOutClean) {
            out.push({
              num_crates: parseInt(outClean),
              operation: 'out__clean',
              id_site: this.storedPlantId,
              date: currentDate,
              type: display.getCell(excelCollumns[typeNum + 1] + ((index * 14) + 2)).value
            })
          }
          let outDirty = display.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 11)).value
          let backupOutDirty = backup.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 11)).value
          if (outDirty !== backupOutDirty) {
            out.push({
              num_crates: parseInt(outDirty),
              operation: 'out__dirty',
              id_site: this.storedPlantId,
              date: currentDate,
              type: display.getCell(excelCollumns[typeNum + 1] + ((index * 14) + 2)).value
            })
          }
          let outRepair = display.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 12)).value
          let backupOutRepair = backup.getCell(excelCollumns[typeNum + 1] + (1 + (index * 14) + 12)).value
          if (outRepair !== backupOutRepair) {
            out.push({
              num_crates: parseInt(outRepair),
              operation: 'out__repair',
              id_site: this.storedPlantId,
              date: currentDate,
              type: display.getCell(excelCollumns[typeNum + 1] + ((index * 14) + 2)).value
            })
          }
        })
        for (var loop = 0; loop < 10; loop += 1) {
          if (display.getCell(excelCollumns[this.target.types.length + 9] + (1 + (index * 14) + 2 + loop)).value !== null) {
            simFalseShipments.push({
              id_site: this.storedPlantId,
              date: currentDate,
              name: display.getCell(excelCollumns[this.target.types.length + 9] + (1 + (index * 14) + 2 + loop)).value,
              qty: display.getCell(excelCollumns[this.target.types.length + 10] + (1 + (index * 14) + 2 + loop)).value
            })
          }
        }
        index += 1
        this.falseEnd = new Date(currentDate)
        currentDate = display.getCell('A' + ((index * 14) + 1)).value
      }
      if (out?.length <= 0 && simFalseShipments.length <= 0) {
        this.$buefy.toast.open({ message: 'No Simulations Found', duration: 10000, type: 'is-warning' })
      }
      this.days = out
      this.newFalseShipments = simFalseShipments
    },
    async saveSimulations () {
      this.isLoading = true
      this.$buefy.toast.open({ message: 'Saving Simulations', duration: 10000, type: 'is-success' })
      if (this.newFalseShipments && this.newFalseShipments.length > 0) {
        await Forecast.createFakeShipments({ shipments: this.newFalseShipments, start: this.falseStart, end: this.falseEnd })
      }
      if (this.days && this.days.length > 0) {
        await Forecast.createSimulation(this.days)
      }
      this.resetData()
      this.getData()
      this.isImportingExcel = false
      this.isLoading = false
    },
    async exportToExcel () {
      const newWorkbook = new exceljs.Workbook()
      newWorkbook.creator = 'GPS Hub'
      newWorkbook.calcProperties.fullCalcOnLoad = true
      const sheet = newWorkbook.addWorksheet('Crate Forecasts')
      const backup = newWorkbook.addWorksheet('DONT TOUCH')

      const excelCollumns = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      this.forecasts.forEach((forecast, numForecast) => {
        sheet.getCell('A' + (1 + (numForecast * 14) + 0)).value = new Date(forecast.date).toLocaleDateString('en-CA')
        sheet.getCell('B' + (1 + (numForecast * 14) + 0)).value = new Date(forecast.date).toLocaleString('en', { weekday: 'long' })
        if (new Date(forecast.date).toLocaleDateString('en-CA') === this.lastDate) {
          sheet.getCell('C' + (1 + (numForecast * 14) + 0)).value = 'Last Production'
          sheet.getCell('C' + (1 + (numForecast * 14) + 0)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '11b800' }
          }
        }
        sheet.getCell('B' + (1 + (numForecast * 14) + 0)).value = new Date(forecast.date).toLocaleString('en', { weekday: 'long' })
        sheet.getCell('A' + (1 + (numForecast * 14) + 1)).value = 'Crate Types'
        sheet.getCell('A' + (1 + (numForecast * 14) + 1)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell('A' + (1 + (numForecast * 14) + 2)).value = 'Clean'
        sheet.getCell('A' + (1 + (numForecast * 14) + 2)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell('A' + (1 + (numForecast * 14) + 3)).value = 'Dirty'
        sheet.getCell('A' + (1 + (numForecast * 14) + 3)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell('A' + (1 + (numForecast * 14) + 4)).value = 'Repair'
        sheet.getCell('A' + (1 + (numForecast * 14) + 4)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell('A' + (1 + (numForecast * 14) + 5)).value = 'Washed'
        sheet.getCell('A' + (1 + (numForecast * 14) + 5)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell('A' + (1 + (numForecast * 14) + 6)).value = 'Repaired'
        sheet.getCell('A' + (1 + (numForecast * 14) + 6)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell('A' + (1 + (numForecast * 14) + 7)).value = 'In Clean'
        sheet.getCell('A' + (1 + (numForecast * 14) + 7)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell('A' + (1 + (numForecast * 14) + 8)).value = 'In Dirty'
        sheet.getCell('A' + (1 + (numForecast * 14) + 8)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell('A' + (1 + (numForecast * 14) + 9)).value = 'In Repair'
        sheet.getCell('A' + (1 + (numForecast * 14) + 9)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell('A' + (1 + (numForecast * 14) + 10)).value = 'Out Clean'
        sheet.getCell('A' + (1 + (numForecast * 14) + 10)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell('A' + (1 + (numForecast * 14) + 11)).value = 'Out Dirty'
        sheet.getCell('A' + (1 + (numForecast * 14) + 11)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell('A' + (1 + (numForecast * 14) + 12)).value = 'Out Repair'
        sheet.getCell('A' + (1 + (numForecast * 14) + 12)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        if (!this.washingDays.includes(new Date(forecast.date).getDay())) {
          sheet.getCell('D' + (1 + (numForecast * 14) + 0)).value = 'No Washing Today'
        }

        forecast.types.forEach((type, index) => {
          let extraCratesIn = 0
          if (this.crateIOs[type][numForecast].totalIn < this.collMeans[type]) {
            extraCratesIn = this.collMeans[type] - this.crateIOs[type][numForecast].totalIn
          }
          // Type Name
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 1)).value = type
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 1)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'd3d3d3' }
          }
          // First table
          if (numForecast === 0) {
            // Set column widths (only done once)
            let colBuffer = sheet.getColumn('A')
            colBuffer.width = 11
            colBuffer = sheet.getColumn('L')
            colBuffer.width = 9
            colBuffer = sheet.getColumn('M')
            colBuffer.width = 20
            colBuffer = sheet.getColumn('N')
            colBuffer.width = 9
            colBuffer = sheet.getColumn('R')
            colBuffer.width = 9
            colBuffer = sheet.getColumn('T')
            colBuffer.width = 10
            colBuffer = sheet.getColumn(excelCollumns[forecast.types.length + 4])
            colBuffer.width = 10
            colBuffer = sheet.getColumn(excelCollumns[forecast.types.length + 5])
            colBuffer.width = 12.5
            // Clean Stock
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 2)).value = forecast.values[type]['CLEAN'].num_crates
            // Dirty Stock
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 3)).value = forecast.values[type]['DIRTY'].num_crates
            // Repair Stock
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 4)).value = forecast.values[type]['REPAIR'].num_crates
          } else {
            // Clean Stock
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 2)).value = { formula: excelCollumns[index + 1] + (((numForecast - 1) * 14) + 3) + '+' + excelCollumns[index + 1] + (((numForecast - 1) * 14) + 6) + '+' + excelCollumns[index + 1] + (((numForecast - 1) * 14) + 8) + '-' + excelCollumns[index + 1] + (((numForecast - 1) * 14) + 11) }
            // Dirty Stock
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 3)).value = { formula: excelCollumns[index + 1] + (((numForecast - 1) * 14) + 4) + '-' + excelCollumns[index + 1] + (((numForecast - 1) * 14) + 6) + '+' + excelCollumns[index + 1] + (((numForecast - 1) * 14) + 7) + '+' + excelCollumns[index + 1] + (((numForecast - 1) * 14) + 9) + '-' + excelCollumns[index + 1] + (((numForecast - 1) * 14) + 12) }
            // Repair Stock
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 4)).value = { formula: excelCollumns[index + 1] + (((numForecast - 1) * 14) + 5) + '-' + excelCollumns[index + 1] + (((numForecast - 1) * 14) + 7) + '+' + excelCollumns[index + 1] + (((numForecast - 1) * 14) + 10) + '-' + excelCollumns[index + 1] + (((numForecast - 1) * 14) + 13) }
          }
          // Washed
          let simWashed = this.rawSimData.filter(x => { return (x.type === type || (type === '5.X' && (x.type === '5.2' || x.type === '5.5'))) && x.operation === 'washing' && new Date(x.date).toLocaleDateString('en-ca') === new Date(forecast.date).toLocaleDateString('en-CA') })
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 5)).value = forecast.washed[type] ? forecast.washed[type] : simWashed.length > 0 ? simWashed[0].num_crates : new Date(forecast.date) < new Date().setDate(new Date().getDate() - 10) || !this.washingDays.includes(new Date(forecast.date).getDay()) ? 0 : this.crateMeans[type + '__' + 'washing']
          if (simWashed.length > 0) {
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 5)).font = {
              color: { argb: '4ca04c' }
            }
          }
          backup.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 5)).value = forecast.washed[type] ? forecast.washed[type] : simWashed.length > 0 ? simWashed[0].num_crates : new Date(forecast.date) < new Date().setDate(new Date().getDate() - 10) || !this.washingDays.includes(new Date(forecast.date).getDay()) ? 0 : this.crateMeans[type + '__' + 'washing']
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 5)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'd8e4bc' }
          }
          // Repaired
          let simRepaired = this.rawSimData.filter(x => { return (x.type === type || (type === '5.X' && (x.type === '5.2' || x.type === '5.5'))) && x.operation === 'repair' && new Date(x.date).toLocaleDateString('en-ca') === new Date(forecast.date).toLocaleDateString('en-CA') })
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 6)).value = forecast.repaired[type] ? forecast.repaired[type] : simRepaired.length > 0 ? simRepaired[0].num_crates : new Date(forecast.date) < new Date().setDate(new Date().getDate() - 10) || !this.washingDays.includes(new Date(forecast.date).getDay()) ? 0 : this.crateMeans[type + '__' + 'repair']
          if (simRepaired.length > 0) {
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 6)).font = {
              color: { argb: '4ca04c' }
            }
          }
          backup.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 6)).value = forecast.repaired[type] ? forecast.repaired[type] : simRepaired.length > 0 ? simRepaired[0].num_crates : new Date(forecast.date) < new Date().setDate(new Date().getDate() - 10) || !this.washingDays.includes(new Date(forecast.date).getDay()) ? 0 : this.crateMeans[type + '__' + 'repair']
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 6)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'd8e4bc' }
          }
          // In Clean
          let simInClean = this.rawSimData.filter(x => { return (x.type === type || (type === '5.X' && (x.type === '5.2' || x.type === '5.5'))) && x.operation === 'in__clean' && new Date(x.date).toLocaleDateString('en-ca') === new Date(forecast.date).toLocaleDateString('en-CA') })
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 7)).value = simInClean.length > 0 ? simInClean[0].num_crates : this.crateIOs[type][numForecast].cleanIn
          if (simInClean.length > 0) {
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 7)).font = {
              color: { argb: '4ca04c' }
            }
          }
          backup.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 7)).value = this.crateIOs[type][numForecast].cleanIn
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 7)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'fcd5b4' }
          }
          // In Dirty
          let simInDirty = this.rawSimData.filter(x => { return (x.type === type || (type === '5.X' && (x.type === '5.2' || x.type === '5.5'))) && x.operation === 'in__dirty' && new Date(x.date).toLocaleDateString('en-ca') === new Date(forecast.date).toLocaleDateString('en-CA') })
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 8)).value = simInDirty.length > 0 ? simInDirty[0].num_crates : new Date(forecast.date) > new Date().setDate(new Date().getDate() - 1) && this.washingDays.includes(new Date(forecast.date).getDay()) ? this.crateIOs[type][numForecast].dirtyIn + extraCratesIn : this.crateIOs[type][numForecast].dirtyIn
          if (simInDirty.length > 0) {
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 8)).font = {
              color: { argb: '4ca04c' }
            }
          }
          backup.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 8)).value = simInDirty.length > 0 ? simInDirty[0].num_crates : new Date(forecast.date) > new Date().setDate(new Date().getDate() - 1) && this.washingDays.includes(new Date(forecast.date).getDay()) ? this.crateIOs[type][numForecast].dirtyIn + extraCratesIn : this.crateIOs[type][numForecast].dirtyIn
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 8)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'fcd5b4' }
          }
          // In Repair
          let simInRepair = this.rawSimData.filter(x => { return (x.type === type || (type === '5.X' && (x.type === '5.2' || x.type === '5.5'))) && x.operation === 'in__repair' && new Date(x.date).toLocaleDateString('en-ca') === new Date(forecast.date).toLocaleDateString('en-CA') })
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 9)).value = simInRepair.length > 0 ? simInRepair[0].num_crates : this.crateIOs[type][numForecast].repairIn
          if (simInRepair.length > 0) {
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 9)).font = {
              color: { argb: '4ca04c' }
            }
          }
          backup.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 9)).value = simInRepair.length > 0 ? simInRepair[0].num_crates : this.crateIOs[type][numForecast].repairIn
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 9)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'fcd5b4' }
          }
          // Out Clean
          let simOutClean = this.rawSimData.filter(x => { return (x.type === type || (type === '5.X' && (x.type === '5.2' || x.type === '5.5'))) && x.operation === 'out__clean' && new Date(x.date).toLocaleDateString('en-ca') === new Date(forecast.date).toLocaleDateString('en-CA') })
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 10)).value = simOutClean.length > 0 ? simOutClean[0].num_crates : this.crateIOs[type][numForecast].outClean
          if (simOutClean.length > 0) {
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 10)).font = {
              color: { argb: '4ca04c' }
            }
          }
          backup.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 10)).value = simOutClean.length > 0 ? simOutClean[0].num_crates : this.crateIOs[type][numForecast].outClean
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 10)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'b7dee8' }
          }
          // Out Dirty
          let simOutDirty = this.rawSimData.filter(x => { return (x.type === type || (type === '5.X' && (x.type === '5.2' || x.type === '5.5'))) && x.operation === 'out__dirty' && new Date(x.date).toLocaleDateString('en-ca') === new Date(forecast.date).toLocaleDateString('en-CA') })
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 11)).value = simOutDirty.length > 0 ? simOutDirty[0].num_crates : this.crateIOs[type][numForecast].outDirty
          if (simOutDirty.length > 0) {
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 11)).font = {
              color: { argb: '4ca04c' }
            }
          }
          backup.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 11)).value = simOutDirty.length > 0 ? simOutDirty[0].num_crates : this.crateIOs[type][numForecast].outDirty
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 11)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'b7dee8' }
          }
          // Out Repair
          let simOutRepair = this.rawSimData.filter(x => { return (x.type === type || (type === '5.X' && (x.type === '5.2' || x.type === '5.5'))) && x.operation === 'out__repair' && new Date(x.date).toLocaleDateString('en-ca') === new Date(forecast.date).toLocaleDateString('en-CA') })
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 12)).value = simOutRepair.length > 0 ? simOutRepair[0].num_crates : this.crateIOs[type][numForecast].outRepair
          if (simOutRepair.length > 0) {
            sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 12)).font = {
              color: { argb: '4ca04c' }
            }
          }
          backup.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 12)).value = simOutRepair.length > 0 ? simOutRepair[0].num_crates : this.crateIOs[type][numForecast].outRepair
          sheet.getCell(excelCollumns[index + 1] + (1 + (numForecast * 14) + 12)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'b7dee8' }
          }
        })
        sheet.getCell(excelCollumns[forecast.types.length + 1] + (1 + (numForecast * 14) + 1)).value = 'TOTAL'
        sheet.getCell(excelCollumns[forecast.types.length + 1] + (1 + (numForecast * 14) + 1)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell(excelCollumns[forecast.types.length + 2] + (1 + (numForecast * 14) + 1)).value = '% MAX'
        sheet.getCell(excelCollumns[forecast.types.length + 2] + (1 + (numForecast * 14) + 1)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell(excelCollumns[forecast.types.length + 3] + (1 + (numForecast * 14) + 1)).value = '% MIN'
        sheet.getCell(excelCollumns[forecast.types.length + 3] + (1 + (numForecast * 14) + 1)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell(excelCollumns[forecast.types.length + 4] + (1 + (numForecast * 14) + 1)).value = 'TOTAL ALL'
        sheet.getCell(excelCollumns[forecast.types.length + 4] + (1 + (numForecast * 14) + 1)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell(excelCollumns[forecast.types.length + 5] + (1 + (numForecast * 14) + 1)).value = '% MAX TOTAL'
        sheet.getCell(excelCollumns[forecast.types.length + 5] + (1 + (numForecast * 14) + 1)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell(excelCollumns[forecast.types.length + 1] + (1 + (numForecast * 14) + 2)).value = { formula: 'SUMIF(' + 'B' + (1 + (numForecast * 14) + 2) + ':' + excelCollumns[forecast.types.length] + (1 + (numForecast * 14) + 2) + ',">0"' + ')' }
        sheet.getCell(excelCollumns[forecast.types.length + 2] + (1 + (numForecast * 14) + 2)).value = { formula: excelCollumns[forecast.types.length + 1] + (1 + (numForecast * 14) + 2) + '/O1*100' }
        sheet.getCell(excelCollumns[forecast.types.length + 3] + (1 + (numForecast * 14) + 2)).value = { formula: excelCollumns[forecast.types.length + 1] + (1 + (numForecast * 14) + 2) + '/Q1*100' }
        sheet.getCell(excelCollumns[forecast.types.length + 4] + (1 + (numForecast * 14) + 2)).value = { formula: 'SUMIF(' + 'B' + (1 + (numForecast * 14) + 2) + ':' + excelCollumns[forecast.types.length] + (1 + (numForecast * 14) + 4) + ',">0"' + ')' }
        sheet.getCell(excelCollumns[forecast.types.length + 5] + (1 + (numForecast * 14) + 2)).value = { formula: excelCollumns[forecast.types.length + 4] + (1 + (numForecast * 14) + 3) + '/M1*100' }
        sheet.getCell(excelCollumns[forecast.types.length + 1] + (1 + (numForecast * 14) + 3)).value = { formula: 'SUMIF(' + 'B' + (1 + (numForecast * 14) + 3) + ':' + excelCollumns[forecast.types.length] + (1 + (numForecast * 14) + 3) + ',">0"' + ')' }
        sheet.getCell(excelCollumns[forecast.types.length + 3] + (1 + (numForecast * 14) + 3)).value = { formula: excelCollumns[forecast.types.length + 1] + (1 + (numForecast * 14) + 3) + '/S1*100' }
        sheet.getCell(excelCollumns[forecast.types.length + 1] + (1 + (numForecast * 14) + 4)).value = { formula: 'SUMIF(' + 'B' + (1 + (numForecast * 14) + 4) + ':' + excelCollumns[forecast.types.length] + (1 + (numForecast * 14) + 4) + ',">0"' + ')' }
        sheet.getCell(excelCollumns[forecast.types.length + 3] + (1 + (numForecast * 14) + 4)).value = { formula: excelCollumns[forecast.types.length + 1] + (1 + (numForecast * 14) + 4) + '/U1*100' }
        if (forecast.inventory) {
          sheet.getCell(excelCollumns[forecast.types.length + 6] + (1 + (numForecast * 14) + 1)).value = 'INVENTORY TODAY'
          sheet.getCell('A' + (1 + (numForecast * 14) + 0)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'ffff00' }
          }
        }
        sheet.getCell(excelCollumns[forecast.types.length + 9] + (1 + (numForecast * 14) + 1)).value = 'Name'
        sheet.getCell(excelCollumns[forecast.types.length + 9] + (1 + (numForecast * 14) + 1)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        sheet.getCell(excelCollumns[forecast.types.length + 10] + (1 + (numForecast * 14) + 1)).value = 'Quantity'
        sheet.getCell(excelCollumns[forecast.types.length + 10] + (1 + (numForecast * 14) + 1)).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'd3d3d3' }
        }
        let dayFalseShipments = this.falseShipments.filter((x) => { return new Date(x.date).toLocaleDateString('en-CA') === new Date(forecast.date).toLocaleDateString('en-CA') })
        for (var loop = 0; loop < dayFalseShipments.length; loop += 1) {
          sheet.getCell(excelCollumns[forecast.types.length + 9] + (1 + (numForecast * 14) + 2 + loop)).value = dayFalseShipments[loop].name // name
          sheet.getCell(excelCollumns[forecast.types.length + 9] + (1 + (numForecast * 14) + 2 + loop)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }
          }
          sheet.getCell(excelCollumns[forecast.types.length + 10] + (1 + (numForecast * 14) + 2 + loop)).value = dayFalseShipments[loop].qty // quantity
          sheet.getCell(excelCollumns[forecast.types.length + 10] + (1 + (numForecast * 14) + 2 + loop)).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f2f2f2' }
          }
        }
        if (forecast.comment) {
          sheet.getCell(excelCollumns[forecast.types.length + 7] + (1 + (numForecast * 14) + 1)).value = forecast.comment?.text
          backup.getCell(excelCollumns[forecast.types.length + 7] + (1 + (numForecast * 14) + 1)).value = forecast.comment?.text
        }
        if (numForecast === 0) {
          sheet.getCell('L1').value = 'Max Total'
          sheet.getCell('M1').value = this.target.max_total
          backup.getCell('M1').value = this.target.max_total
          sheet.getCell('N1').value = 'Max Clean'
          sheet.getCell('O1').value = this.target.max_clean
          backup.getCell('O1').value = this.target.max_clean
          sheet.getCell('P1').value = 'Min Clean'
          sheet.getCell('Q1').value = this.target.min_clean
          backup.getCell('Q1').value = this.target.min_clean
          sheet.getCell('R1').value = 'Min Dirty'
          sheet.getCell('S1').value = this.target.min_dirty
          backup.getCell('S1').value = this.target.min_dirty
          sheet.getCell('T1').value = 'Min Repair'
          sheet.getCell('U1').value = this.target.min_repair
          backup.getCell('U1').value = this.target.min_repair
        }
      })
      var buffer = await newWorkbook.xlsx.writeBuffer('exportedData.xlsx')
      saveAs(new Blob([buffer]), this.selectedPlant.name + '-' + this.selectedPlant.id + new Date().toLocaleDateString('en-CA') + '.xlsx')
    },
    async submitComment (archive) {
      // `editableComment` is a direct reference to the forecast object in
      // `this.forecasts`, and its `comment` property always pre-exists (either a
      // comment object or null, see getData). So once the API call succeeds we can
      // mutate that comment in place for an instant visual update, instead of
      // triggering a full resetData()/getData() reload.
      if (this.editableComment.comment && (this.editableComment.comment.text !== this.bufferText)) {
        Forecast.updateComment({
          id_site: this.editableComment.comment.id_site,
          date: this.editableComment.comment.date,
          text: this.bufferText,
          id: this.editableComment.comment.id
        }).then(() => {
          this.editableComment.comment.text = this.bufferText
          this.isEditingComment = false
        })
      }
      if (!this.editableComment.comment && (this.bufferText && this.bufferText.length > 0)) {
        const date = this.editableComment.date
        Forecast.createComment({
          id_site: this.storedPlantId,
          date,
          text: this.bufferText
        }).then(() => {
          // createComment returns only a 200 (no body), so fetch the comments for
          // the current range to recover the new comment's id — much cheaper than
          // reloading the whole forecast dataset.
          return Forecast.getComments({
            start: this.dateStart.toLocaleDateString('en-CA'),
            end: this.dateEnd.toLocaleDateString('en-CA'),
            siteId: this.selectedPlant.id
          })
        }).then((comments) => {
          const created = comments.find(x => new Date(x.date).toLocaleDateString('en-CA') === date)
          this.editableComment.comment = created || {
            id_site: this.storedPlantId,
            date,
            text: this.bufferText
          }
          this.isEditingComment = false
        })
      }
      if (this.editableComment.comment && archive === true) {
        Forecast.deleteComment({
          id: this.editableComment.comment.id
        }).then(() => {
          this.editableComment.comment = null
          this.isEditingComment = false
        })
      }
    },
    // Normalises an editable field to a Number (or null when cleared) so that
    // comparisons against the original value don't drop decimals. Using parseInt
    // here previously truncated float means (e.g. 12.53 -> 12), which registered
    // a phantom "change" on every type and created unwanted simulations.
    simNum (val) {
      return val === null || val === undefined || val === '' ? null : Number(val)
    },
    async submitEdit () {
      var outSimulations = []
      if (!this.editBatch) {
        this.editDateEnd = this.editDateStart
      }
      try {
        const editFields = [
          { editable: this.editableWashed, original: this.originalWashed, operation: 'washing' },
          { editable: this.editableRepaired, original: this.originalRepaired, operation: 'repair' },
          { editable: this.editableIn, original: this.originalIn, operation: 'in' },
          { editable: this.editableOut, original: this.originalOut, operation: 'out' }
        ]
        for (var d = new Date(this.editDateStart); d <= this.editDateEnd; d.setDate(d.getDate() + 1)) {
          if (this.editBatch && (!this.washingDays.includes(d.getDay()) || this.holidays.includes(d.toLocaleDateString('en-CA')))) {

          } else {
            this.editableForecast.types.forEach((type) => {
              editFields.forEach(({ editable, original, operation }) => {
                const value = this.simNum(editable[type])
                if (value !== this.simNum(original[type])) {
                  outSimulations.push({
                    num_crates: Math.round(value),
                    operation: operation,
                    id_site: this.storedPlantId,
                    date: d.toLocaleDateString('en-CA'),
                    type: type
                  })
                }
              })
            })
          }
        }
        Forecast.createSimulation(outSimulations).then(() => {
          this.editableForecast = null
          this.originalForecast = null
          this.resetData()
          this.getData()
          this.isEditingForecast = false
        })
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
    },
    pinData () {
      this.pinnedData.push({
        crateForecast: this.crateForecasts.filter(x => x.type === this.activeTab),
        storedDate: this.storedDate,
        key: this.pinnedData.length
      })
    },
    closeInfoCard () {
      this.infoCard = false
    },
    closeMeanCard () {
      this.meanCard = false
    },
    async resetSimulations (flags = {}) {
      await Forecast.resetSimulations({
        id_site: this.selectedPlant.id,
        ...flags
      })
      this.isResetting = false
      this.resetData()
      this.getData()
    },
    async archiveSelected () {
      if (this.selectedResetRows.length === 0) {
        return
      }
      if (this.resetTableType === 'falseShipments') {
        await Forecast.archiveFakeShipments(this.selectedResetRows)
      } else if (this.resetTableType === 'movedShipments') {
        await Forecast.archiveMovedShipments(this.selectedResetRows)
      } else {
        await Forecast.archiveSimulations(this.selectedResetRows)
      }
      this.selectedResetRows = []
      this.resetData()
      this.getData()
    },
    // --- Moved shipments: shipment-view drag & drop, new predictions, submit ---
    normDate (d) {
      return d ? new Date(d).toLocaleDateString('en-CA') : null
    },
    // Rebuilds this.crateIOs from this.collects (+ the stored sim data) so the
    // shipment view reflects optimistic moves without a server round-trip. Mirrors
    // the original inline build in getData; assigns a fresh object for reactivity.
    buildCrateIOs () {
      const crateIOs = {}
      const collTypes = this.target.types ? this.target.types.map(x => x.name) : []
      const endCollLoop = new Date(this.dateEnd).setDate(this.dateEnd.getDate() + 1)
      const simData = this.simData || []
      const simLimit = this.simLimit
      /* eslint-disable no-unmodified-loop-condition */
      collTypes.forEach(colltype => {
        crateIOs[colltype] = []
        for (var startCollLoop = new Date(this.dateStart); startCollLoop <= endCollLoop; startCollLoop.setDate(startCollLoop.getDate() + 1)) {
          let simIn = false
          let simOut = false
          let predColls = this.collects.filter(x => {
            return !x.done_date && !(x.shipment === null && x.done !== 'T' && (x.shipType === 'COL' || x.shipType === 'NCR' || x.shipType === 'TRFI')) && new Date(x.date).toLocaleDateString('en-CA') === startCollLoop.toLocaleDateString('en-CA') && (x.type === colltype || (colltype === '5.X' && (x.type === '5.2' || x.type === '5.5')))
          })
          let doneColls = this.collects.filter(x => {
            return x.done_date && !(x.shipment === null && x.done !== 'T' && (x.shipType === 'COL' || x.shipType === 'NCR' || x.shipType === 'TRFI')) && new Date(x.done_date).toLocaleDateString('en-CA') === startCollLoop.toLocaleDateString('en-CA') && (x.type === colltype || (colltype === '5.X' && (x.type === '5.2' || x.type === '5.5')))
          })
          let totalIn = 0
          let cleanIn = 0
          let dirtyIn = 0
          let repairIn = 0
          if (simData.filter(x => {
            return x.operation.split('__')[0] === 'in' && new Date(x.date).toLocaleDateString('en-CA') === startCollLoop.toLocaleDateString('en-CA') && (x.type === colltype || (colltype === '5.X' && (x.type === '5.2' || x.type === '5.5'))) && new Date(x.date) > simLimit
          }).length > 0) {
            simIn = true
            totalIn = simData.filter(x => {
              return x.operation.split('__')[0] === 'in' && new Date(x.date).toLocaleDateString('en-CA') === startCollLoop.toLocaleDateString('en-CA') && (x.type === colltype || (colltype === '5.X' && (x.type === '5.2' || x.type === '5.5')))
            })[0].num_crates
          } else {
            totalIn = predColls.filter(x => {
              return x.shipType === 'COL' || x.shipType === 'TRFI' || x.shipType === 'NCR'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0) + doneColls.filter(x => {
              return x.shipType === 'COL' || x.shipType === 'TRFI' || x.shipType === 'NCR'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0)
            cleanIn = predColls.filter(x => {
              return (x.shipType === 'COL' || x.shipType === 'TRFI' || x.shipType === 'NCR') && x.status === 'CLEAN'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0) + doneColls.filter(x => {
              return (x.shipType === 'COL' || x.shipType === 'TRFI' || x.shipType === 'NCR') && x.status === 'CLEAN'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0)
            dirtyIn = predColls.filter(x => {
              return (x.shipType === 'COL' || x.shipType === 'TRFI' || x.shipType === 'NCR') && x.status === 'DIRTY'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0) + doneColls.filter(x => {
              return (x.shipType === 'COL' || x.shipType === 'TRFI' || x.shipType === 'NCR') && x.status === 'DIRTY'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0)
            repairIn = predColls.filter(x => {
              return (x.shipType === 'COL' || x.shipType === 'TRFI' || x.shipType === 'NCR') && x.status === 'REPAIR'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0) + doneColls.filter(x => {
              return (x.shipType === 'COL' || x.shipType === 'TRFI' || x.shipType === 'NCR') && x.status === 'REPAIR'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0)
          }
          let totalOut = 0
          let outClean = 0
          let outDirty = 0
          let outRepair = 0
          if (simData.filter(x => {
            return x.operation.split('__')[0] === 'out' && new Date(x.date).toLocaleDateString('en-CA') === startCollLoop.toLocaleDateString('en-CA') && (x.type === colltype || (colltype === '5.X' && (x.type === '5.2' || x.type === '5.5'))) && new Date(x.date) > simLimit
          }).length > 0) {
            simOut = true
            totalOut = simData.filter(x => {
              return x.operation.split('__')[0] === 'out' && new Date(x.date).toLocaleDateString('en-CA') === startCollLoop.toLocaleDateString('en-CA') && (x.type === colltype || (colltype === '5.X' && (x.type === '5.2' || x.type === '5.5')))
            })[0].num_crates
          } else {
            outClean = predColls.filter(x => {
              return (x.shipType === 'DEL' || x.shipType === 'TRFO') && x.status === 'CLEAN'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0) + doneColls.filter(x => {
              return (x.shipType === 'DEL' || x.shipType === 'TRFO') && x.status === 'CLEAN'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0)
            outDirty = predColls.filter(x => {
              return (x.shipType === 'DEL' || x.shipType === 'TRFO') && x.status === 'DIRTY'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0) + doneColls.filter(x => {
              return (x.shipType === 'DEL' || x.shipType === 'TRFO') && x.status === 'DIRTY'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0)
            outRepair = predColls.filter(x => {
              return (x.shipType === 'DEL' || x.shipType === 'TRFO') && x.status === 'REPAIR'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0) + doneColls.filter(x => {
              return (x.shipType === 'DEL' || x.shipType === 'TRFO') && x.status === 'REPAIR'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0)
            totalOut = predColls.filter(x => {
              return x.shipType === 'DEL' || x.shipType === 'TRFO'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0) + doneColls.filter(x => {
              return x.shipType === 'DEL' || x.shipType === 'TRFO'
            }).reduce((sum, element) => sum + parseInt(element.num_crates), 0)
          }
          crateIOs[colltype].push({
            collDate: startCollLoop.toLocaleDateString('en-CA'),
            totalIn: totalIn,
            cleanIn: cleanIn,
            dirtyIn: dirtyIn,
            repairIn: repairIn,
            totalOut: totalOut,
            outClean: outClean,
            outDirty: outDirty,
            outRepair: outRepair,
            predCollsIn: predColls.filter(x => {
              return x.shipType === 'COL' || x.shipType === 'TRFI' || x.shipType === 'NCR'
            }),
            predCollsOut: predColls.filter(x => {
              return x.shipType === 'DEL' || x.shipType === 'TRFO'
            }),
            doneCollsIn: doneColls.filter(x => {
              return x.shipType === 'COL' || x.shipType === 'TRFI' || x.shipType === 'NCR'
            }),
            doneCollsOut: doneColls.filter(x => {
              return x.shipType === 'DEL' || x.shipType === 'TRFO'
            }),
            simIn: simIn,
            simOut: simOut
          })
        }
      })
      /* eslint-enable no-unmodified-loop-condition */
      this.crateIOs = crateIOs
    },
    // Combines the per-type crateIOs for one day into the {done,pred}Colls{In,Out}
    // buckets the shipment-view tables render from.
    computeDayMoves (dateStr) {
      let allColls = []
      const combined = { doneCollsIn: [], doneCollsOut: [], predCollsIn: [], predCollsOut: [] }
      this.selectedTypes.forEach((x) => {
        if (this.crateIOs[x.name]) {
          allColls = allColls.concat(this.crateIOs[x.name].filter((c) => c.collDate === dateStr))
        }
      })
      allColls.forEach((coll) => {
        combined.doneCollsIn = combined.doneCollsIn.concat(coll.doneCollsIn)
        combined.doneCollsOut = combined.doneCollsOut.concat(coll.doneCollsOut)
        combined.predCollsIn = combined.predCollsIn.concat(coll.predCollsIn)
        combined.predCollsOut = combined.predCollsOut.concat(coll.predCollsOut)
      })
      return combined
    },
    rebuildShipmentView () {
      this.buildCrateIOs()
      this.forecasts.forEach((f) => { f.dayMoves = this.computeDayMoves(f.date) })
    },
    isMovable (move) {
      return !move.done_date
    },
    moveOutline (move) {
      if (move._pending) return '2px dashed rgb(255, 140, 0)'
      if (move._moved) return '2px solid rgb(70, 110, 220)'
      return ''
    },
    moveTitle (move) {
      if (move._new) return 'New predicted shipment — pending, not yet saved'
      if (move._pending) return 'Moved to this day — pending, not yet saved'
      if (move._moved) return move.originDate ? ('Previously moved (originally ' + move.originDate + ')') : 'Previously moved / predicted shipment'
      return 'Drag to another day to move this shipment'
    },
    onDragStart (event, move) {
      if (!this.isMovable(move)) return
      this.draggingOb = move.id
      if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = 'move'
        event.dataTransfer.setData('text/plain', String(move.id))
      }
      // Native HTML5 drag locks the wheel, so we auto-scroll the window when the
      // pointer nears the top/bottom edge — days are stacked vertically and moving
      // a shipment a week out means dragging well past the visible cards.
      this.dragPointerY = event.clientY
      this.startDragScroll()
    },
    onDragEnd () {
      this.draggingOb = null
      this.dragOverDate = null
      this.stopDragScroll()
    },
    onDragOver (event, dateStr) {
      if (!this.draggingOb) return
      this.dragOverDate = dateStr
      this.dragPointerY = event.clientY
    },
    onDrop (dateStr) {
      if (this.draggingOb) this.moveShipment(this.draggingOb, dateStr)
      this.draggingOb = null
      this.dragOverDate = null
      this.stopDragScroll()
    },
    startDragScroll () {
      if (this.dragScrollRaf) return
      const edge = 110 // px from a viewport edge where auto-scroll kicks in
      const maxSpeed = 24 // px per frame at the very edge
      const step = () => {
        if (!this.draggingOb) { this.dragScrollRaf = null; return }
        const y = this.dragPointerY
        const h = window.innerHeight
        let dy = 0
        if (y < edge) dy = -maxSpeed * (1 - y / edge)
        else if (y > h - edge) dy = maxSpeed * (1 - (h - y) / edge)
        if (dy !== 0) window.scrollBy(0, dy)
        this.dragScrollRaf = requestAnimationFrame(step)
      }
      this.dragScrollRaf = requestAnimationFrame(step)
    },
    stopDragScroll () {
      if (this.dragScrollRaf) {
        cancelAnimationFrame(this.dragScrollRaf)
        this.dragScrollRaf = null
      }
    },
    // Moves every un-scanned row that shares this OB to the target day. An OB can
    // be several material rows, but a truck can only arrive once — so they snap
    // together. Scanned rows (done_date) are left alone: a real scan always wins.
    moveShipment (ob, targetDateStr) {
      const rows = this.collects.filter((c) => c.id === ob && !c.done_date)
      if (rows.length === 0) return
      if (rows.every((c) => this.normDate(c.date) === targetDateStr)) return
      rows.forEach((c) => {
        c.date = targetDateStr + 'T00:00:00'
        c._pending = this.normDate(c.date) !== this.normDate(c._baseDate)
      })
      this.rebuildShipmentView()
    },
    openNewPrediction (dateStr) {
      this.newPrediction = {
        shipment_type: 'COL',
        ship_from: '',
        ship_to: '',
        crate_type: this.selectedTypes.length > 0 ? this.selectedTypes[0].name : '5.2',
        crate_status: 'DIRTY',
        num_crates: null
      }
      this.predictionDate = new Date(dateStr + 'T00:00:00')
      this.isAddingPrediction = true
    },
    addPrediction () {
      if (!this.predictionDate || !this.newPrediction.num_crates) {
        this.$buefy.toast.open({ message: 'A date and quantity are required', duration: 4000, type: 'is-warning' })
        return
      }
      const dateStr = this.predictionDate.toLocaleDateString('en-CA')
      const key = 'new-' + (this.pendingNewCounter++)
      // The site is always one end of the shipment: it arrives here (in) or leaves from here (out).
      // Force the site-side code to the site id so the forecast engine counts it on reload.
      const shipFrom = this.predictionIsIn ? this.newPrediction.ship_from : this.storedPlantId
      const shipTo = this.predictionIsIn ? this.storedPlantId : this.newPrediction.ship_to
      this.collects.push({
        id: 'PENDING-' + key,
        _key: key,
        _new: true,
        _pending: true,
        _moved: true,
        _baseDate: null,
        done: 'F',
        shipment: 'PREVISION',
        ship_to: shipTo,
        ship_from: shipFrom,
        name: this.predictionIsIn ? shipTo : shipFrom,
        shipType: this.newPrediction.shipment_type,
        date: dateStr + 'T00:00:00',
        originDate: null,
        type: this.newPrediction.crate_type,
        status: this.newPrediction.crate_status,
        num_crates: parseInt(this.newPrediction.num_crates) || 0,
        done_date: null,
        relic: false,
        naval: false,
        route: null
      })
      this.rebuildShipmentView()
      this.isAddingPrediction = false
    },
    discardPending () {
      this.collects = this.collects.filter((c) => !c._new)
      this.collects.forEach((c) => {
        c.date = c._baseDate
        c._pending = false
      })
      this.rebuildShipmentView()
    },
    async submitMoves () {
      if (this.pendingCount === 0) return
      this.isSubmittingMoves = true
      const createPayloads = []
      const editPayloads = []
      const movedByOb = {}
      this.collects.forEach((c) => {
        if (c._new) {
          createPayloads.push({
            id_site: this.storedPlantId,
            is_new: true,
            shipment_type: c.shipType,
            ship_from: c.ship_from,
            ship_to: c.ship_to,
            crate_type: c.type,
            crate_status: c.status,
            moved_date: this.normDate(c.date),
            num_crates: parseInt(c.num_crates) || 0
          })
        } else if (this.normDate(c.date) !== this.normDate(c._baseDate)) {
          movedByOb[c.id] = c
        }
      })
      Object.keys(movedByOb).forEach((ob) => {
        const c = movedByOb[ob]
        const movedDate = this.normDate(c.date)
        let existing = null
        if (typeof ob === 'string' && ob.indexOf('MOVED-') === 0) {
          const recId = parseInt(ob.slice('MOVED-'.length))
          existing = this.movedShipments.find((m) => m.id === recId)
        } else {
          existing = this.movedShipments.find((m) => !m.is_new && m.ob === ob)
        }
        if (existing) {
          editPayloads.push({
            id: existing.id,
            shipment_type: c.shipType,
            ship_from: c.ship_from,
            ship_to: c.ship_to,
            crate_type: c.type,
            crate_status: c.status,
            moved_date: movedDate,
            num_crates: existing.num_crates
          })
        } else {
          createPayloads.push({
            id_site: this.storedPlantId,
            is_new: false,
            ob: ob,
            shipment_type: c.shipType,
            ship_from: c.ship_from,
            ship_to: c.ship_to,
            crate_type: c.type,
            crate_status: c.status,
            moved_date: movedDate
          })
        }
      })
      let anySaved = false
      try {
        this.$buefy.toast.open({ message: 'Saving shipment changes', duration: 8000, type: 'is-success' })
        if (createPayloads.length > 0) {
          await Forecast.createMovedShipments(createPayloads)
          anySaved = true
        }
        for (const payload of editPayloads) {
          await Forecast.editMovedShipment(payload)
          anySaved = true
        }
      } catch (error) {
        this.$buefy.toast.open({ message: 'Error saving changes: ' + error.message, duration: 10000, type: 'is-danger' })
      }
      // Re-sync with the server whenever anything persisted, so a retry can't
      // re-send already-saved creates (create is not idempotent — edits are, being
      // keyed by id). If nothing saved (e.g. the create call itself failed), keep
      // the pending changes so the user can simply retry them.
      if (anySaved) {
        this.resetData()
        await this.getData()
      }
      this.isSubmittingMoves = false
    },
    async getData () {
      sessionStorage.setItem('consultingPlant', JSON.stringify(this.selectedPlant))
      sessionStorage.setItem('dateStart', JSON.stringify(this.dateStart))
      sessionStorage.setItem('dateEnd', JSON.stringify(this.dateEnd))
      this.isLoading = true
      this.forecasts = []
      this.crateForecasts = []
      this.crateMeans = []
      this.collMeans = []
      this.falseShipments = []
      this.crateIOs = []
      this.bookings = []
      this.target = []
      this.inventories = []
      this.washingDays = []
      this.storedPlantId = this.selectedPlant.id
      this.storedName = this.selectedPlant.name
      let commentData = null
      this.$buefy.toast.open({ message: 'Loading Data', duration: 10000, type: 'is-success' })
      try {
        const data = await Forecast.get({
          start: this.dateStart.toLocaleDateString('en-CA'),
          end: this.dateEnd.toLocaleDateString('en-CA'),
          siteId: this.selectedPlant.id,
          collectMean: this.collectMeanCounts,
          washingMean: this.washingMeanCounts,
          repairMean: this.repairMeanCounts,
          rejectMean: this.rejectMeanCounts,
          deliveryMean: this.deliveryMeanCounts,
          ...(this.selectedPlant.id === 'FRA0' && { weeklyMeanSimorep: this.weeklyMeanSimorep })
        })
        commentData = await Forecast.getComments({
          start: this.dateStart.toLocaleDateString('en-CA'),
          end: this.dateEnd.toLocaleDateString('en-CA'),
          siteId: this.selectedPlant.id
        })
        this.holidays = await Forecast.getHolidays({
          siteId: this.selectedPlant.id
        })
        this.falseShipments = data.falseShipments
        this.movedShipments = data.movedShipments || []
        // Working copy of the (already move-applied) collects. `_baseDate` is the
        // effective date at load so we can detect/undo optimistic moves; `_new`
        // flags predictions staged this session that don't exist server-side yet.
        this.collects = (data.collects || []).map((c, i) => ({
          ...c,
          _key: 'c' + i,
          _baseDate: c.date,
          _new: false,
          _pending: false
        }))
        this.holidays = this.holidays.map((x) => { return new Date(x.date).toLocaleDateString('en-CA') })
        this.inventories = data.inventories && data.inventories.length > 0 ? data.inventories : []
        this.washingDays = data.washingDays && data.washingDays.length > 0 ? data.washingDays : [1, 2, 3, 4, 5]
        this.target = (data.targetStock && data.targetStock.length > 0) ? {
          id: data.targetStock[0].id,
          id_site: this.selectedPlant.id,
          max_dirty: data.targetStock[0].max_dirty,
          min_dirty: data.targetStock[0].min_dirty,
          max_clean: data.targetStock[0].max_clean,
          min_clean: data.targetStock[0].min_clean,
          max_total: data.targetStock[0].max_total,
          min_repair: data.targetStock[0].min_repair,
          min_available: data.targetStock[0].min_available,
          types: JSON.parse(data.targetStock[0].types)
        } : {
          id_site: this.selectedPlant.id,
          max_dirty: 0,
          min_dirty: 0,
          max_clean: 0,
          min_clean: 0,
          max_total: 0,
          min_repair: 0,
          min_available: 0,
          types: [{ name: '5.2' }]
        }
        this.siteTypes = this.target.types
        this.selectedTypes = this.siteTypes
        const simData = await Forecast.getSimulation({
          start: this.dateStart.toLocaleDateString('en-CA'),
          end: this.dateEnd.toLocaleDateString('en-CA'),
          siteId: this.selectedPlant.id,
          types: this.siteTypes.map(x => x.name)
        })
        this.rawSimData = simData
        this.simData = simData
        let simLimit = new Date(Math.max.apply(null, data.movements.map((e) => {
          if (e.movements.length > 0) {
            return new Date(e.date)
          }
          return new Date('2019-11-11')
        })))
        this.lastDate = simLimit.toLocaleDateString('en-CA')
        simLimit.setDate(simLimit.getDate() + 1)
        this.simLimit = simLimit
        simData.forEach((element) => {
          if (new Date(element.date).toLocaleDateString('en-CA') >= simLimit.toLocaleDateString('en-CA')) {
            if (this.siteTypes.map(x => x.name).includes('5.X') && element.type === '5.2') {
              this.simulations[new Date(element.date).toLocaleDateString('en-CA') + '__' + element.operation + '__' + '5.X'] = element.num_crates
            }
            this.simulations[new Date(element.date).toLocaleDateString('en-CA') + '__' + element.operation + '__' + element.type] = element.num_crates
          }
        })
        if (this.siteTypes.map(x => x.name).includes('5.X')) {
          this.collMeans = data.meanColl
          this.collMeans['5.X'] = this.collMeans['5.2'] + this.collMeans['5.5']
        } else {
          this.collMeans = data.meanColl
        }
        data.forecasts.forEach((element) => {
          var dayMoves = data.movements.filter((x) => { return (new Date(x.date).toLocaleDateString('en-CA') === new Date(element.date).toLocaleDateString('en-CA') && x.movements.length > 0) })
          this.crateForecasts.push({
            ...element,
            movements: dayMoves.length > 0 ? dayMoves.reduce((combined, current) => {
              return combined.concat(current.movements)
            }, []) : null
          })
        })
        if (this.siteTypes.map(x => x.name).includes('5.X')) {
          data.means.forEach((element) => {
            if (element.type === '5.2' || element.type === '5.5') {
              if (this.crateMeans['5.X' + '__' + element.operation]) {
                this.crateMeans['5.X' + '__' + element.operation] += element.mean
              } else {
                this.crateMeans['5.X' + '__' + element.operation] = element.mean
              }
            } else {
              this.crateMeans[element.type + '__' + element.operation] = element.mean
            }
          })
        } else {
          data.means.forEach((element) => {
            this.crateMeans[element.type + '__' + element.operation] = element.mean
          })
        }

        var collTypes = this.target.types.map(x => x.name)
        this.undecidedCollsIn = await data.collects.filter(x => {
          return (collTypes.includes(x.type) || (collTypes.includes('5.X') && (x.type === '5.2' || x.type === '5.5'))) && ((x.shipment === null && x.done !== 'T') || (new Date(x.done_date).toLocaleDateString('en-CA') === new Date('09-09-2018').toLocaleDateString('en-CA') || (x.date === null && x.done_date === null))) && !(x.shipType === 'TRFO' || x.shipType === 'DEL')
        })
        this.undecidedCollsIn.sort((a, b) => new Date(b.originDate) - new Date(a.originDate))
        if (this.undecidedCollsIn.length > 0) {
          this.totalUndecidedIn = this.undecidedCollsIn.reduce((sum, element) => sum + parseInt(element.num_crates), 0)
        }
        this.undecidedCollsOut = await data.collects.filter(x => {
          return (collTypes.includes(x.type) || (collTypes.includes('5.X') && (x.type === '5.2' || x.type === '5.5'))) && ((new Date(x.done_date).toLocaleDateString('en-CA') === new Date('09-09-2018').toLocaleDateString('en-CA') || (x.date === null && x.done_date === null))) && (x.shipType === 'TRFO' || x.shipType === 'DEL')
        })
        this.undecidedCollsOut.sort((a, b) => new Date(b.originDate) - new Date(a.originDate))
        if (this.undecidedCollsOut.length > 0) {
          this.totalUndecidedOut = this.undecidedCollsOut.reduce((sum, element) => sum + parseInt(element.num_crates), 0)
        }
        this.buildCrateIOs()
      } catch (error) {
        this.$buefy.toast.open({ message: 'Error loading data:' + error.message, duration: 10000, type: 'is-warning' })
      }
      this.crateForecasts.forEach(element => {
        let types = [...new Set(element.forecasts.map(x => {
          return x.status.split('__')[0]
        }))]
        if (collTypes.includes('5.X')) {
          types.splice(types.indexOf('5.2'), 1)
          types.splice(types.indexOf('5.5'), 1)
          types.push('5.X')
        }
        let statuses = [...new Set(element.forecasts.map(x => {
          return x.status.split('__')[1]
        }))]
        let values = []
        let moves = element.movements
        let washed = []
        let repaired = []
        let total = 0
        let dirty = 0
        let clean = 0
        let repair = 0
        let available = 0
        let inventory = false
        let comments = commentData.filter(x => new Date(x.date).toLocaleDateString('en-CA') === new Date(element.date).toLocaleDateString('en-CA'))
        types.forEach(type => {
          values[type] = []
          washed[type] = !moves ? null : moves.filter((x) => {
            return (x.operation === 'washing' || x.operation === 'machineWash') && (x.status_crate_start.split('__')[0] === type || (type === '5.X' && (x.status_crate_start.split('__')[0] === '5.2' || x.status_crate_start.split('__')[0] === '5.5')))
          }).reduce((sum, move) => sum + move.num_crates, 0)
          repaired[type] = !moves ? null : moves.filter((x) => {
            return x.operation === 'repair' && (x.status_crate_start.split('__')[0] === type || (type === '5.X' && (x.status_crate_start.split('__')[0] === '5.2' || x.status_crate_start.split('__')[0] === '5.5')))
          }).reduce((sum, move) => sum + move.num_crates, 0)
          statuses.forEach(status => {
            let buffer = []
            if (type === '5.X') {
              buffer = element.forecasts.filter((x) => {
                return x.status === '5.2' + '__' + status || x.status === '5.5' + '__' + status
              })
              buffer = {
                changed: buffer[0].changed && buffer[1].changed,
                collChanged: buffer[0].collChanged && buffer[1].collChanged,
                num_crates: buffer[0].num_crates + buffer[1].num_crates,
                status: '5.X' + '__' + status
              }
            } else {
              buffer = element.forecasts.filter((x) => {
                return x.status === type + '__' + status
              })[0]
            }
            values[type][status] = {
              num_crates: buffer.num_crates,
              changed: buffer.changed
            }
            if (this.inventories.filter((x) => {
              return new Date(x.date).toLocaleDateString('en-CA') === new Date(element.date).toLocaleDateString('en-CA')
            }).length > 0) {
              inventory = true
            }
            if (buffer.num_crates > 0) {
              total += buffer.num_crates
              if (status === 'CLEAN' || status === 'DIRTY') {
                available += buffer.num_crates
              }
              if (status === 'CLEAN') {
                clean += buffer.num_crates
              } else if (status === 'DIRTY') {
                dirty += buffer.num_crates
              } else if (status === 'REPAIR') {
                repair += buffer.num_crates
              }
            }
          })
        })
        this.forecasts.push({
          date: new Date(element.date).toLocaleDateString('en-CA'),
          types: types,
          statuses: statuses,
          values: values,
          washed: washed,
          repaired: repaired,
          total: total,
          dirty: dirty,
          clean: clean,
          repair: repair,
          available: available,
          inventory: inventory,
          comment: comments && comments.length > 0 ? comments[0] : null,
          dayMoves: this.computeDayMoves(new Date(element.date).toLocaleDateString('en-CA'))
        })
      })
      this.isLoading = false
    }
  }
}

</script>

<style scoped>
.shipping-detail {
  display: block;
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -ms-flex-negative: 1;
  flex-shrink: 1;
  padding: 0.10rem;
}
</style>
